/* eslint-disable */
import { LanguageStorage } from "./localization";

export const lng: LanguageStorage = {
  en: {
    auth: {
      downloadAuthenticatorApps: "Download a two-factor authenticator app like Microsoft Authenticator: {0} and {1}, or Google Authenticator for {2} and {3}.",
      downloadMicrosoftAuthenticator: "Download a two-factor authenticator app like Microsoft Authenticator for",
      enterCodeYouReceived: "Enter the code you received",
      intoYourTfaApp: "into your two-factor authenticator app. Spaces and case are not important.",
      orEnterThisKey: "or enter this key",
      orGoogleAuthenticator: "or Google Authenticator for",
      scanQrCodeBelow: "Scan the QR code below:",
      scanQrCodeOrEnterKey: "Scan the QR code or enter this key",
      scanQrCodeOrEnterKeyIntoTfaApp: "Scan the QR code or enter this key <b>{0}</b> into your two-factor authenticator app. Spaces and case are not important.",
      toUseAuthAppFollowSteps: "To use an authenticator app, follow these steps:",
      wrongCredentials: "Username or password are not correct.",
      invalidTfaCode: "The entered code is invalid. Please verify and try again or request a new code if needed.",
      accountLocked: "We regret to inform you that your account has been locked due to recent security concerns. If you need more information or assistance, please contact our support team at your earliest convenience."
    },
    benefModels: {
      partnership: {
        name: "Partnership model",
        order: [
          "Surviving mortgage debtor, failing that",
          "Spouse, failing that",
          "Other heirs"
        ]
      },
      alternative: {
        name: "Alternative model",
        order: [
          "Spouse or registered partner, failing that",
          "Other heirs"
        ]
      }
    },
    btn: {
      backToLogin: "Back to login",
      cancel: "Cancel",
      complete: "Complete",
      confirm: "Confirm",
      confirmDetails: "Confirm details",
      confirmPassword: "Confirm password",
      edit: "Edit",
      forgotPassword: "Forgot password?",
      iAgree: "I agree",
      iDoNotAgree: "I do not agree",
      learnMore: "Learn more",
      logIn: "Log in",
      refuse: "Refuse",
      resetPassword: "Reset password",
      skipProduct: "Skip product",
      submit: "Submit",
      submitApplication: "Submit application",
      updateProfile: "Update profile",
      yesCancel: "Yes, cancel",
      callBroker: "Call"
    },
    code: "en",
    common: {
      and: "and",
      loading: "Loading...",
      next: "Next",
      no: "No",
      ok: "OK",
      outOf: "out of",
      until: "until",
      yes: "Yes",
      your: "Your"
    },
    dataProtec: {
      communication: "Communication",
      dataProtectionProvisions: "Data protection provisions",
      paragraph1: "<h2>Privacy and data</h2><p>UKB's processing of your personal data is conducted in compliance with the provisions of Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of individuals with regard to personal data processing and on the free movement of such data, and with Organic Law 3/2018 of 5 December on the Protection of Personal Data and the Guarantee of Digital Rights (hereinafter, the LOPDGDD). Accordingly, we hereby inform you that Banque Cantonale Neuchâteloise (hereinafter, “UKB”) is the data controller.</p><p>As the data controller, UKB has the technical, organisational and human resources needed to guarantee the security and protection of its information systems, along with the customer information and data they host.</p><p>We will not transfer your personal data to any third parties, unless it is to comply with a legal obligation or unless you give your consent. However, service providers that UKB engages or may engage as data processors may have access to your personal data. In these cases, UKB guarantees the confidentiality of the personal data provided to third parties, and that they will apply appropriate security measures.</p><p>Your personal data will be processed to comply with the applicable legal obligations and with the rights and obligations specified in your contracts with us.</p>",
      paragraph2: "<h2>Use of personal data</h2><p>You can find information on how the bank obtains your data, the purposes for which it processes your data, the legal basis for this, the recipients of the data and your rights with regard to personal data processing at <a href=\"https://www.bankinter.com/file_source/nbol/nav/seguridad-privacidad/uso_datos_personales_en.pdf\" target=\"_blank\" rel=\"noopener\">Information on the use of personal data.</a>.",
      usingTheWebsite: "Using the website"
    },
    faq: {
      DI: {
        title: "Todesfallversicherung",
        docName: "Factsheet",
        link: "assets/Factsheet_TodesfallVersicherung_De.pdf",
        faqs: [
          { "q": "Was ist die 'Todesfallversicherung' für eine Versicherung?", "a": "Die Todesfallversicherung ist eine reine Risiko-Lebensversicherung. Ein Todesfall bringt das Leben der Hinterbliebenen aus dem Gleichgewicht. Es fallen hohe Kosten an und es fällt ein Einkommen plötzlich aus. Die Kapitalauszahlung schützt die Angehörigen vor einer grossen finanziellen Belastung und sichert die Finanzierung der Lebenskosten." },
          { "q": "Wer kann eine Hypothekar-Todesfallversicherung abschliessen?", "a": "Eine natürliche Person muss folgende generelle Kriterien für den Beitritt in den Kollektivversicherungsvertrag erfüllen: <ul class=\"list-inside ml-2 list-[lower-alpha]\" ><li>in der Schweiz wohnhaft (die Enklaven auf Schweizer Territorium werden hier nicht dazugezählt)</li><li>zwischen 18 und 60 Jahre alt sein</li><li>darf keine US Person sein (Was ist mit Doppelbürgerschaften und Green Card?)</li><li>muss eine Hypothek bei der Post Finance abgeschlossen haben </li></ul><br/> Weiter muss der Kunde: <ul class=\"list-inside ml-2 list-[lower-alpha]\" ></ul><li>eine einfache Gesundheitsdeklaration ausfüllen</li><li>sein Rauchverhalten deklarieren</li>" },
          { "q": "Welche Deckungen können gewählt werden?", "a": "Wichtig ist, zu verstehen, dass Ihr Versicherungsschutz immer auf der Basis Ihrer Hypothek entsteht und Sie innerhalb der folgenden Parameter Ihre Deckung wählen können: <ol class=\"list-inside ml-2 list-[lower-alpha]\" ><ul>1. Der maximal wählbare Versicherungsschutz wird von der Höhe des Hypothekarbetrags abgeleitet. </ul> <ul>2. Vom Hypothekarbetrag können 100%, 75%, 50% oder 25% abgesichert werden.</ul><ul>3. Einschränkungen: Die Versicherungssumme entspricht grundsätzlich max. der Hypothekarschuld, bei Hypothekarsummen >2 Mio. entspricht das max. CHF 2 Mio., bei geringen Hypothekarsummen liegt die minimale Absicherung bei CHF 50k.</ul> <ul>4. Bei zwei Hypothekarnehmern kann der Versicherungsschutz auf die beiden Personen verteilt werden. Total darf jedoch die Höhe der Hypothek nicht überschritten werden, vgl. Punkt 3 </ul><ul>5. Die Versicherungssumme nimmt analog der geleisteten Amortisation (direkt und indirekt) ab - proportional zum gewählten %-Baustein.</ul> </ol>" },
          { "q": "Wie finde ich die passende Deckung?", "a": "Die passende Deckung hängt in erster Linie von der finanziellen Situation der Hinterbliebenen ab. Oft entstehen im Unglücksfall finanzielle Engpässe für Ihre Liebsten. Je höher die Versicherungssumme in diesem Fall, desto mehr 'Gestaltungsfreiheit' und Zeit das Leben in geordnete Bahnen zu bringen für Ihre Hinterbliebenen. Gleichzeitig bezahlen Sie für höhere Leistungen mehr Prämie. Die richtige Balance ist sehr individuell. Wir empfehlen die Leistungen aus der Pensionskasse und weiteren Versicherungen zu berücksichtigen." },
          { "q": "Bleibt die Prämie konstant über die Laufzeit?", "a": "Nein. Die Höhe der Prämie berechnet sich aus der Höhe des Todesfallkapitals, sowie dem Alter der versicherten Person. Dies bedeutet: Die Prämie wird jährlich an Ihr aktuelles Alter angepasst - sie steigt dadurch über die Vertragslaufzeit grundsätzlich an. Gleichzeitig - sofern Sie einen Amortisationsteil haben - sinkt ihr Todesfallkapital jährlich um die Amortisation und damit sinkt der Prämienteil ebenfalls. Mit Erhalt der jährlichen Versicherungsbestägigung sind Todesfallkaptial und Prämie für das nächste Verischerungsjahr ersichtlich." },
          { "q": "Was passiert im Todesfall?", "a": "Die Angehörigen melden den Todesfall dem Kundenberater. Dieser wiederumg leitet die Information an Ihren Versicherungspartner 'AXA' weiter. Folglich werden im Zusammenspiel zwischen Kundenberater und AXA die notwendigen Dokumente bei den Hinterblibenen angefordert und die Ansprüche geprüft." },
          { "q": "Wo muss ich den Todesfallschein und das Erbverzeichnis einreichen?", "a": "Nur der Todesfallschein und die Kontaktangaben der Angehörigen müssen digital via RM Claims Prozess eingereicht werden. Das Erbverzeichnis wurde bereits geklärt. Sie eröffnen hierzu einen Schadenfall für den Kunden. Dort können Sie das Dokument als pdf hochladen und an AXA senden." },
        ]
      },
      PPI: {
        title: "Zahlungsschutzversicherung",
        docName: "Factsheet",
        link: "assets/Factsheet_ZahlungsschutzVersicherung_De.pdf",
        faqs: [
          { "q": "Was ist der 'Zahlungsschutz' für eine Versicherung?", "a": "Mit der Zahlungsschutzversicherung wird der versicherte Anteil Ihrer monatlichen Hypothekarverpflichtungen während maximal 12 Monaten weiterbezahlt, wenn Sie arbeitsunfähig (Unfall/Krankheit) oder unverschuldet arbeitslos werden." },
          { "q": "Wer kann vom Zahlungsschutz profitieren?", "a": "Eine Person muss folgende generelle Kriterien für einen Versicherungsabschluss erfüllen: <ul class=\"list-inside ml-2 list-[lower-alpha]\"> <li>muss in der Schweiz wohnhaft sein (die Enklaven auf Schweizer Territorium werden hier nicht dazugezählt)</li> <li>muss zwischen 18 und 60 Jahre alt sein</li> <li>muss einen Hypothekarvertrag bei der {bank} abgeschlossen haben</li> <li>einer festen und bezahlten Beschäftigung in der Schweiz unter einem unbefristeten, ungekündigten Arbeitsvertrag nachgehen und mindestens 20 Stunden pro Woche bei demselben Arbeitgeber beschäftigt oder selbständig erwerbend sein</li> </ul>" },
          { "q": "Welche Deckungen kann ich wählen?", "a": "Abgedeckt ist der in der Versicherungsbestätigung aufgeführten Teil (40% oder 80%) der monatliche Rate der Hypothekarverpflichtungen (effektiver Hypothekarzins inkl. allfälligem Amortisationsbetrag aller von der versicherten Person bei der Post Finance im Rahmen des Hypothekarvertrages abgeschlossenen Hypothekartranchen) bei einer vollständigen Arbeitsunfähigkeit infolge Krankheit / Unfall oder einer unverschuldeten Arbeitslosigkeit." },
          { "q": "Weshalb unterscheidet sich die Prämie?", "a": "Die versicherte Rate wird jährlich den effektiven Hypothekarverpflichtungen (effektiver Hypothekarzins inkl. allfälligem Amortisationsbetrag) angepasst. Bei SARON Anteilen wird der zu dieser Zeit geltende Zinssatz verwendet." },
          { "q": "Wie melde ich einen Leistungsfall?", "a": "Sie können den Prozess ganz einfach im Kunden-Dashboard starten, indem Sie auf 'Meine Versicherungen' und dort anschliessend auf das Plus-Symbol klicken, 'Versicherungsfall melden' auswählen und den Anweisungen auf dem Bildschirm für die Zahlungsschutzversicherung folgen." },
          { "q": "Was ist eine 'Wartefrist'?", "a": "Die Wartefrist ist der Zeitraum, in dem nach einem versicherten Ereignis noch keine Leistungen bezogen werden können." },
          { "q": "Was ist eine 'Karenzfrist'?", "a": "Eine Karenzfrist bei Versicherungen bezieht sich auf einen festgelegten Zeitraum, der nach Abschluss einer Versicherungspolice verstreichen muss, bevor bestimmte Leistungen oder Deckungen in Kraft treten. Während dieser Karenzfrist können auch im Schadenfall keine Versicherungsansprüche geltend gemacht werden. Die Karenzfrist dient dazu, die Versicherung vor Missbrauch zu schützen und sicherzustellen, dass der Versicherungsnehmer regelmässige Beiträge zahlt, bevor Leistungen in Anspruch genommen werden können." },
        ]
      }
    },
    decls: {
      vag45: {
        content: [],
        name: "VAG",
        link: "assets/KundenbriefVAG_En_V03.05.pdf"
      },
      smokerStatus: {
        content: [
          "<div class=\"flex items-start text-body\"> Ausgewählt während dem Gespräch mit Ihrem Kundenberater: </div> <div class=\"w-full inline-flex flex-row items-center items-center\"> <EmptyCircle class=\"w-6 h-8 stroke-2 mr-2\" /> <div class=\"flex-1 text-base\">Ja, regelmässig</div> </div> <div class=\"w-full inline-flex flex-row items-center items-center\"> <EmptyCircle class=\"w-6 h-8 stroke-2 mr-2\" /> <div class=\"flex-1 text-base\">Ja, gelegentlich</div> </div> <div class=\"w-full inline-flex flex-row items-center items-center\"> <CheckCircle class=\"w-6 h-8 stroke-2 mr-2\" /> <div class=\"flex-1 text-base\"><b>Nein. Ich habe in den letzten 12 Monaten keine Tabak oder Tabakersatzprodukte* konsumiert.</b></div> </div> <div class=\"flex items-start text-body\"> *Darunter fallen: Zigaretten oder Zigarillos, Zigarren, Pfeife, elektronische Zigaretten, Kau- oder Schnupftabak, Nikotin Gum / Patch oder Wasserpfeife (Shisha) </div>"
        ],
        name: "Do you smoke?",
      },
      declarationOfAccession: {
        content: [
          "I am between 18 and 60 years old, not retired and have my main residence in Switzerland.",
          "I have a permanent, permanent job with no notice and work more than 20 hours a week for an employer or I am self-employed. The employment contract is a permanent and paid job in Switzerland.",
          "I acknowledge that insurance cover only applies after the deadlines specified in the general terms and conditions have expired.",
          "I am particularly aware that pre-existing conditions and existing illnesses may be excluded from coverage for incapacity for work. Insurance cover for total incapacity for work does not extend to claims (pre-existing conditions) that are due to pre-existing incapacity for work or to existing illnesses (in particular illnesses or accidents) two years before the start of the insurance, which I already know about or should have known about.",
          "I am aware that as a self-employed person and business owner, etc., I have no insurance cover for unemployment. The same applies to managing partners of a company and senior employees in an “employer-like position” who are not entitled to unemployment benefits due to their special position in the company."
        ],
        name: "Declaration of Accession"
      },
      gtc: {
        content: [
          "Please open the link to the <a href=\"assets/AVB_EN.pdf\" class=\"underline underline-offset-1\" target=\"_blank\">General Terms and Conditions</a> and confirm that you have read and understood the contents of the document:"
        ],
        name: "General Terms and Conditions",
        link: "assets/AVB_EN.pdf"
      },
      gtcDI: {
        content: [
          "Please open the link to the <a href=\"assets/AVB_DI_En.pdf\" class=\"underline underline-offset-1\" target=\"_blank\">General Insurance Conditions (GIC)</a> and confirm that you have read and understood the content of the document."
        ],
        name: "General Insurance Conditions",
        link: "assets/AVB_DI_En.pdf"
      },
      gtcPPI: {
        content: [
          "Please open the link to the <a href=\"assets/AVB_PP_En.pdf\" class=\"underline underline-offset-1\" target=\"_blank\">General Insurance Conditions (GIC)</a> and confirm that you have read and understood the content of the document."
        ],
        name: "General Insurance Conditions",
        link: "assets/AVB_PP_En.pdf"
      },
      healthDeclaration: {
        content: [
          "I am physically and mentally healthy, i.e. I do not suffer from a chronic illness, health impairment or birth defect.",
          "I am not in treatment and no treatment is planned.",
          "I have never been in treatment for more than a year and have never taken medication for more than a year (including painkillers, sleeping pills or antidepressants).",
          "I have not taken any drugs in the last six months.",
          "I am fully able to work and have never been unable to work or earn a living for more than two months in the last five years."
        ],
        name: "Health Declaration"
      },
      powerOfAttorney: {
        content: [
          "I authorise AXA Schweiz to obtain information from its subsidiaries, other insurance institutions, official bodies and in particular from doctors, therapists, clinics, care facilities, employers, pension and health insurance companies, pension and vested benefits institutions, compensation funds, and other persons and bodies that have relevant information in order to determine the obligation to pay benefits in the event of death, and to pass on personal data to reinsurers and other insurance institutions belonging to AXA Schweiz to the extent necessary, and release the above-mentioned persons and bodies from their duty of confidentiality. This release from their duty of confidentiality expressly applies beyond death."
        ],
        name: "Power of Attorney"
      }
    },
    description: "English",
    error: {
      atLeast1LowercaseLetter: "At least 1 lowercase letter",
      atLeast1Numeral: "At least 1 numeral (0-9)",
      atLeast1SpecialChar: "At least 1 special character (!@#$%^&*()-_+.)",
      atLeast1UppercaseLetter: "At least 1 uppercase letter",
      atLeast8CharsLong: "At least 8 characters long",
      codeRequired: "Code required",
      confirmPasswordIsRequired: "Confirm Password is required",
      newPasswordIsRequired: "New Password is required",
      passwordsMustMatch: "Passwords must match",
    },
    isDefault: false,
    label: {
      smokerStatusIsTruthful: "I confirm that this statement is true",
      aboveInformationIsTruthful: "The above information is truthful to the best of my knowledge.",
      accountHolderName: "Account holder name",
      address1: "Address 1",
      address2: "Address 2",
      annual: "Annual",
      bankName: "Bank name",
      bankPostalCode: "Bank postal code",
      byCheckingBoxReadUnderstoodTermsAndConditions: "By checking this box, I state that I have read and understood the terms and conditions.",
      city: "City",
      confirmationPending: "Confirmation pending",
      confirmed: "Confirmed",
      confirmPassword: "Confirm password",
      contractNumber: "Contract number",
      coverageAmountDI: "Death benefit",
      coverageAmountPPI: "Insured monthly rate",
      coverageTotal: "Coverage",
      coveragePerMonth: "Coverage per month",
      customerType: "Customer type",
      dateOfEvent: "Date of event",
      desiredPaymentFrequency: "Desired payment frequency",
      dueBy: "Due by",
      durationOfInsurance: "Duration of insurance",
      email: "Email",
      firstName: "First name",
      grossPrice: "Gross price",
      halfYearly: "Half yearly",
      iban: "IBAN",
      incapacityForWorkAccident: "Incapacity for work due to accident",
      incapacityForWorkIllness: "Incapacity for work due to illness",
      incidentDate: "Incident date",
      insuranceEvent: "Insurance event",
      invoiceNumber: "Invoice number",
      issuedAt: "Issued at",
      lastName: "Last name",
      monthly: "Monthly",
      newPassword: "New password",
      offeredBy: "Offered by",
      paidAt: "Paid at",
      payment: "Payment",
      phone: "Phone",
      policyNumber: "Policy number",
      postalCode: "Postal code",
      premium: "Premium",
      premiumPerMonth: "Premium per month",
      costPerMonth: "Cost per month",
      premiumPerQuarter: "Cost per quarter",
      premiumPerYear: "Cost per year",
      serviceFees: "Monthly fee for quarterly payment",
      quarterly: "Quarterly",
      resetPassword: "Reset password",
      startDate: "Start date",
      status: "Status",
      subStatus: "Substatus",
      total: "Total",
      totalPremiumPerMonth: "Total premium per month",
      unemployment: "Unemployment",
      validFrom: "Valid from",
      validTo: "Valid to",
      yearly: "Yearly",
      yourCode: "Your code",
      yourEmail: "Your email",
      yourPassword: "Your password",
      searchFaq: "Filter",
      dataprotectionprovisionslink: "<a href=\"https://www.axa.ch/de/informationen/datenschutz.html\" class=\"underline\" target=\"_blank\">Data protection provisions</a>"
    },
    menu: {
      activateAccount: "Activate Account",
      cart: "Cart",
      claim: "Claim",
      contactRM: "Contact RM",
      installments: "Policy Instalments",
      insurance: "Insurance",
      insuranceCancellation: "Insurance cancellation",
      invoices: "Invoices",
      login: "Login",
      logout: "Logout",
      messages: "Messages",
      orderOfBeneficiaries: "Order of beneficiaries",
      outstandingInvoices: "Outstanding invoices",
      policies: "Policies",
      profile: "Profile",
      reportClaim: "Report claim",
      support: "Support"
    },
    noData: {
      activePolicies: "No active policies to display.",
      claims: "No claims submitted.",
    },
    notice: {
      areYouSureYouWantCancelInsurance: "Are you sure you want to cancel your insurance?",
      areYouSureYouWantExerciseRightOfCancellation: "Are you sure you want to exercise your right of cancellation?",
      changeSuccessful: "Change successful",
      chooseOrderOfBeneficiariesForDeathInsurance: "Choose the order of beneficiaries for your death insurance:",
      ifInformationIsIncorrectPleaseContactRm: "If the information is incorrect, please contact your relationship manager.",
      insuranceEndsOn: "The insurance coverage ends on:",
      pleaseCheckEmail: "Please check your email inbox to reset your password.",
      pleaseCheckPersonalInformation: "Please check your personal information and correct it if necessary.",
      pleaseContactYourAdvisor: "Please contact your RM for more details",
      pleaseEnterCodeWeSentToNumber: "Please enter the code we sent to {0}.",
      pleaseVerifyMobileNumber: "Please verify your mobile number",
      resendSms: "Resend SMS",
      sinceWhenAreYouDisabled: "Since when are you disabled?",
      somethingWentWrongPleaseTryAgain: "Something went wrong. Please try again",
      success: "Success!",
      thankYouFindYourClaimHere: "Thank you for taking the time. You can find your claim report in your customer dashboard under <b>Claims</b>.",
      thankYouForApplicationFindYourConfirmation: "You can view your offer at any time in your personal account. We will also send you access to your customer account via email.",
      thankYouYouCanNowSubmitMembershipApplication: "Thank you! You can now submit your membership application(s).",
      whenDoesYourEmploymentEnd: "When does your employment end?",
      youAreCancellingInsuranceRetroactivelyPleaseNoteCancellationTakesEffectImmediately: "You are in the process of cancelling the insurance relationship retroactively to the start of the insurance. Please note that the cancellation takes effect immediately and irrevocably.",
      youAreInTheProcessOfCancellingInsurancePleaseNoteEndOfInsuranceTermListedBelow: "You are in the process of cancelling the insurance you have chosen. Please note that the end of the insurance term is listed below.",
      youHaveSuccessfullySubmittedYourClaimAxaWillContactYou: "You have successfully submitted your insurance claim. AXA will contact you via email.",
      yourClaimHasBeenSubmitted: "Your claim has been submitted",
      yourProductIsActivated: "Your product is activated",
      yearlyDiscount: "Bitte beachten Sie, dass unser Servicedienstleister (Additiv AG) Ihre Zahlung um CHF 20.- pro Quartal rabattiert, wenn Sie die jährliche Zahlungsweise wählen.",
    },
    policy: {
      additionalDocumentApprovals: "Please read and confirm the following content:",
      installment: "Instalment",
      installmentXOutOfY: "Instalment {0} out of {1}",
      noDocuments: "No visible documents to display.",
      noInstallments: "No policy instalments to display.",
      policyStart: "Policy start date",
      yourDocuments: "Your documents"
    },
    products: {
      DI: {
        description: "To protect your loved ones",
        name: "Family protection",
        customName: "Family protection"
      },
      PPI: {
        description: "To ensure the loan is paid out",
        name: "Payment protection",
        customName: "Payment protection"
      }
    },
    smoker: {
      noIHaveNotConsumedTobaccoInLast12Months: "No. I have not consumed tobacco or tobacco substitute products* in the last 12 months.",
      selectedDuringTheMeetingWithAccountManager: "Selected during the conversation with your customer advisor:",
      thisIncludesCigarettesEtAl: "* This includes: cigarettes or cigarillos, cigars, pipes, electronic cigarettes, chewing or snuff tobacco, nicotine gum / patch or water pipe (shisha)",
      yesOccasionally: "Yes, occasionally",
      yesRegularly: "Yes, regularly",
    },
    title: {
      bankDetails: "Bank details",
      cancelInsurance: "Cancel insurance",
      cart: "Cart",
      choosePolicy: "Choose policy",
      claimDetails: "Claim details",
      confirmNewPassword: "Confirm new password",
      insuranceDamage: "Insurance claims",
      invoices: "Invoices",
      login: "Login",
      orderOfBeneficiaries: "Order of beneficiaries",
      pleaseReadAndConfirmPrivacyPolicy: "Please read and confirm the privacy policy",
      provisionalQuote: "Provisional quote",
      resetPassword: "Reset password",
      setPasswordForYourPersonalArea: "Set a password for your personal customer area",
      summary: "Summary",
      welcome: "Welcome",
      welcomeJohnDoe: "Welcome, {0}",
      yourActivePolicies: "Your policies",
      yourActivePolicy: "Your policy",
      yourActiveProducts: "Your active products",
      yourOffers: "Offer(s)",
      yourOffersAccepted: "Your insurance(s)",
      yourBroker: "Your relationship manager"
    }
  },
  de: {
    auth: {
      downloadAuthenticatorApps: "Laden Sie eine Zwei-Faktor-Authentifikator-App wie Microsoft Authenticator herunter: {0} und {1}, oder Google Authenticator für {2} und {3}.",
      downloadMicrosoftAuthenticator: "Laden Sie eine Zwei-Faktor-Authentifikator-App wie Microsoft Authenticator herunter für",
      enterCodeYouReceived: "Geben Sie den Code ein, den Sie erhalten haben",
      intoYourTfaApp: "in Ihre Zwei-Faktor-Authentifikator-App ein. Leerzeichen und Groß-/Kleinschreibung sind nicht wichtig.",
      orEnterThisKey: "oder geben Sie diesen Code",
      orGoogleAuthenticator: "oder Google Authenticator für",
      scanQrCodeBelow: "Scannen Sie den QR-Code unten:",
      scanQrCodeOrEnterKey: "Scannen Sie den QR-Code oder geben Sie diesen Code",
      scanQrCodeOrEnterKeyIntoTfaApp: "Scannen Sie den QR-Code oder geben Sie diesen Code <b>{0}</b> in Ihre Zwei-Faktor-Authentifikator-App ein. Leerzeichen und Groß-/Kleinschreibung sind nicht wichtig.",
      toUseAuthAppFollowSteps: "Um eine Authentifizierungs-App zu verwenden, führen Sie die folgenden Schritte aus:",
      wrongCredentials: "Ihre angegebene E-Mail oder Ihr Passwort ist falsch.",
      invalidTfaCode: "Der eingegebene Code ist ungültig. Bitte überprüfen Sie ihn und versuchen Sie es erneut oder fordern Sie bei Bedarf einen neuen Code an.",
      accountLocked: "Wir bedauern, Ihnen mitteilen zu müssen, dass Ihr Konto aufgrund jüngster Sicherheitsbedenken gesperrt wurde. Wenn Sie weitere Informationen oder Unterstützung benötigen, kontaktieren Sie bitte unser Support-Team so bald wie möglich."
    },
    benefModels: {
      partnership: {
        name: "Modell 1 (Standardbegünstigung gemäss AVB)",
        order: [
          "Überlebende Hypothekarschuldnerin bzw. den überlebenden Hypothekarschuldner, bei deren bzw. dessen Fehlen",
          "Die Ehepartnerin bzw. den Ehepartner oder die eingetragene Partnerin bzw. den eingetragenen Partner, bei deren bzw. dessen Fehlen",
          "Die Erbinnen und Erben der versicherten Person"
        ]
      },
      alternative: {
        name: "Modell 2",
        order: [
          "Die Ehepartnerin bzw. den Ehepartner oder die eingetragene Partnerin bzw. den eingetragenen Partner, bei deren bzw. dessen Fehlen",
          "Die Erbinnen und Erben der versicherten Person"
        ]
      }
    },
    btn: {
      backToLogin: "Zurück zur Anmeldung",
      cancel: "Abbrechen",
      complete: "Abschliessen",
      confirm: "Bestätigen",
      confirmDetails: "Angaben bestätigen",
      confirmPassword: "Passwort bestätigen",
      edit: "Bearbeiten",
      forgotPassword: "Passwort vergessen?",
      iAgree: "Ich stimme zu",
      iDoNotAgree: "Ich stimme nicht zu",
      learnMore: "Mehr erfahren",
      logIn: "Anmelden",
      refuse: "Verneinen",
      resetPassword: "Passwort zurücksetzen",
      skipProduct: "Überspringen",
      submit: "Einreichen",
      submitApplication: "Antrag absenden",
      updateProfile: "Profil aktualisieren",
      yesCancel: "Ja, widerrufen",
      callBroker: "Kundenberater:in anrufen"
    },
    code: "de",
    common: {
      and: "und",
      loading: "Wird geladen...",
      next: "Weiter",
      no: "Nein",
      ok: "OK",
      outOf: "von",
      until: "bis",
      yes: "Ja",
      your: "Ihre"
    },
    dataProtec: {
      communication: "Kommunikation",
      dataProtectionProvisions: "Informationen zum Datenschutz",
      paragraph1: "Liebe Kundin <br/><br/> Auf den folgenden Seiten finden Sie eine Zusammenfassung der gemachten Angaben sowie der gewählten Versicherungslösung. Wir bitten Sie, Ihre Informationen zu überprüfen. <br/><br/> Die Personendaten, welche Sie im Zusammenhang mit der vorliegenden Vermittlung UKB anvertrauen und bekannt geben, werden von UKB vertraulich behandelt und von UKB ausschliesslich im Rahmen der vorliegenden Vermittlung an AXA sowie weitere berechtigte Dritte weitergegeben und verwendet. <br/><br/> Über die Datenbearbeitung der jeweiligen Partei können sie sich hier informieren: <br/> <br/> Banque Cantonale Neuchâteloise <a href=\"https://postfinance.ch/dse\" class=\"underline\" target=\"_blank\">https://postfinance.ch/dse</a> <br/> AXA Versicherungen AG / AXA Leben AG <a href=\"https://www.axa.ch/datenschutz\" class=\"underline\" target=\"_blank\">https://www.axa.ch/datenschutz</a> <br/>",
      paragraph2: "Mit Abschluss bestätigen Sie die Richtigkeit und Vollständigkeit der gemachten Angaben. Sie bestätigen zudem, die UKB von der Geheimhaltungspflicht sowie dem Bankkundengeheimnis im Rahmen des bereits unterzeichneten Entbindungsformulars entbunden zu haben und der Weitergabe Ihrer Daten zuzustimmen. Überdies bitten wir Sie zur Kenntnis zu nehmen, dass Ihre Informationen unverschlüsselt an Sie übermittelt werden können.",
      usingTheWebsite: "Nutzung Website"
    },
    faq: {
      DI: {
        title: "Todesfallversicherung",
        docName: "Informationsblatt",
        link: "assets/Factsheet_TodesfallVersicherung_De.pdf",
        faqs: [
          { "q": "Was ist die 'Todesfallversicherung' für eine Versicherung?", "a": "Die Todesfallversicherung ist eine reine Risiko-Lebensversicherung. Ein Todesfall bringt das Leben der Hinterbliebenen aus dem Gleichgewicht. Es fallen hohe Kosten an und es fällt ein Einkommen plötzlich aus. Die Kapitalauszahlung schützt die Angehörigen vor einer grossen finanziellen Belastung und sichert die Finanzierung der Lebenskosten." },
          { "q": "Wer kann eine Hypothekar-Todesfallversicherung abschliessen?", "a": "Eine natürliche Person muss folgende generelle Kriterien für den Beitritt in den Kollektivversicherungsvertrag erfüllen: <ul class=\"list-inside ml-2 list-[lower-alpha]\" ><li>in der Schweiz wohnhaft (die Enklaven auf Schweizer Territorium werden hier nicht dazugezählt)</li><li>zwischen 18 und 60 Jahre alt sein</li><li>darf keine US Person sein (Was ist mit Doppelbürgerschaften und Green Card?)</li><li>muss eine Hypothek bei der Post Finance abgeschlossen haben </li></ul><br/> Weiter muss der Kunde: <ul class=\"list-inside ml-2 list-[lower-alpha]\" ></ul><li>eine einfache Gesundheitsdeklaration ausfüllen</li><li>sein Rauchverhalten deklarieren</li>" },
          { "q": "Welche Deckungen können gewählt werden?", "a": "Wichtig ist, zu verstehen, dass Ihr Versicherungsschutz immer auf der Basis Ihrer Hypothek entsteht und Sie innerhalb der folgenden Parameter Ihre Deckung wählen können: <ol class=\"list-inside ml-2 list-[lower-alpha]\" ><ul>1. Der maximal wählbare Versicherungsschutz wird von der Höhe des Hypothekarbetrags abgeleitet. </ul> <ul>2. Vom Hypothekarbetrag können 100%, 75%, 50% oder 25% abgesichert werden.</ul><ul>3. Einschränkungen: Die Versicherungssumme entspricht grundsätzlich max. der Hypothekarschuld, bei Hypothekarsummen >2 Mio. entspricht das max. CHF 2 Mio., bei geringen Hypothekarsummen liegt die minimale Absicherung bei CHF 50k.</ul> <ul>4. Bei zwei Hypothekarnehmern kann der Versicherungsschutz auf die beiden Personen verteilt werden. Total darf jedoch die Höhe der Hypothek nicht überschritten werden, vgl. Punkt 3 </ul><ul>5. Die Versicherungssumme nimmt analog der geleisteten Amortisation (direkt und indirekt) ab - proportional zum gewählten %-Baustein.</ul> </ol>" },
          { "q": "Wie finde ich die passende Deckung?", "a": "Die passende Deckung hängt in erster Linie von der finanziellen Situation der Hinterbliebenen ab. Oft entstehen im Unglücksfall finanzielle Engpässe für Ihre Liebsten. Je höher die Versicherungssumme in diesem Fall, desto mehr 'Gestaltungsfreiheit' und Zeit das Leben in geordnete Bahnen zu bringen für Ihre Hinterbliebenen. Gleichzeitig bezahlen Sie für höhere Leistungen mehr Prämie. Die richtige Balance ist sehr individuell. Wir empfehlen die Leistungen aus der Pensionskasse und weiteren Versicherungen zu berücksichtigen." },
          { "q": "Bleibt die Prämie konstant über die Laufzeit?", "a": "Nein. Die Höhe der Prämie berechnet sich aus der Höhe des Todesfallkapitals, sowie dem Alter der versicherten Person. Dies bedeutet: Die Prämie wird jährlich an Ihr aktuelles Alter angepasst - sie steigt dadurch über die Vertragslaufzeit grundsätzlich an. Gleichzeitig - sofern Sie einen Amortisationsteil haben - sinkt ihr Todesfallkapital jährlich um die Amortisation und damit sinkt der Prämienteil ebenfalls. Mit Erhalt der jährlichen Versicherungsbestägigung sind Todesfallkaptial und Prämie für das nächste Verischerungsjahr ersichtlich." },
          { "q": "Was passiert im Todesfall?", "a": "Die Angehörigen melden den Todesfall dem Kundenberater. Dieser wiederumg leitet die Information an Ihren Versicherungspartner 'AXA' weiter. Folglich werden im Zusammenspiel zwischen Kundenberater und AXA die notwendigen Dokumente bei den Hinterblibenen angefordert und die Ansprüche geprüft." },
          { "q": "Wo muss ich den Todesfallschein und das Erbverzeichnis einreichen?", "a": "Nur der Todesfallschein und die Kontaktangaben der Angehörigen müssen digital via RM Claims Prozess eingereicht werden. Das Erbverzeichnis wurde bereits geklärt. Sie eröffnen hierzu einen Schadenfall für den Kunden. Dort können Sie das Dokument als pdf hochladen und an AXA senden." },
        ]
      },
      PPI: {
        title: "Zahlungsschutz",
        docName: "Informationsblatt",
        link: "assets/Factsheet_ZahlungsschutzVersicherung_De.pdf",
        faqs: [
          { "q": "Was ist der 'Zahlungsschutz' für eine Versicherung?", "a": "Mit der Zahlungsschutzversicherung wird der versicherte Anteil Ihrer monatlichen Hypothekarverpflichtungen während maximal 12 Monaten weiterbezahlt, wenn Sie arbeitsunfähig (Unfall/Krankheit) oder unverschuldet arbeitslos werden." },
          { "q": "Wer kann vom Zahlungsschutz profitieren?", "a": "Eine Person muss folgende generelle Kriterien für einen Versicherungsabschluss erfüllen: <ul class=\"list-inside ml-2 list-[lower-alpha]\"> <li>muss in der Schweiz wohnhaft sein (die Enklaven auf Schweizer Territorium werden hier nicht dazugezählt)</li> <li>muss zwischen 18 und 60 Jahre alt sein</li> <li>muss einen Hypothekarvertrag bei der {bank} abgeschlossen haben</li> <li>einer festen und bezahlten Beschäftigung in der Schweiz unter einem unbefristeten, ungekündigten Arbeitsvertrag nachgehen und mindestens 20 Stunden pro Woche bei demselben Arbeitgeber beschäftigt oder selbständig erwerbend sein</li> </ul>" },
          { "q": "Welche Deckungen kann ich wählen?", "a": "Abgedeckt ist der in der Versicherungsbestätigung aufgeführten Teil (40% oder 80%) der monatliche Rate der Hypothekarverpflichtungen (effektiver Hypothekarzins inkl. allfälligem Amortisationsbetrag aller von der versicherten Person bei der Post Finance im Rahmen des Hypothekarvertrages abgeschlossenen Hypothekartranchen) bei einer vollständigen Arbeitsunfähigkeit infolge Krankheit / Unfall oder einer unverschuldeten Arbeitslosigkeit." },
          { "q": "Weshalb unterscheidet sich die Prämie?", "a": "Die versicherte Rate wird jährlich den effektiven Hypothekarverpflichtungen (effektiver Hypothekarzins inkl. allfälligem Amortisationsbetrag) angepasst. Bei SARON Anteilen wird der zu dieser Zeit geltende Zinssatz verwendet." },
          { "q": "Wie melde ich einen Leistungsfall?", "a": "Sie können den Prozess ganz einfach im Kunden-Dashboard starten, indem Sie auf 'Meine Versicherungen' und dort anschliessend auf das Plus-Symbol klicken, 'Versicherungsfall melden' auswählen und den Anweisungen auf dem Bildschirm für die Zahlungsschutzversicherung folgen." },
          { "q": "Was ist eine 'Wartefrist'?", "a": "Die Wartefrist ist der Zeitraum, in dem nach einem versicherten Ereignis noch keine Leistungen bezogen werden können." },
          { "q": "Was ist eine 'Karenzfrist'?", "a": "Eine Karenzfrist bei Versicherungen bezieht sich auf einen festgelegten Zeitraum, der nach Abschluss einer Versicherungspolice verstreichen muss, bevor bestimmte Leistungen oder Deckungen in Kraft treten. Während dieser Karenzfrist können auch im Schadenfall keine Versicherungsansprüche geltend gemacht werden. Die Karenzfrist dient dazu, die Versicherung vor Missbrauch zu schützen und sicherzustellen, dass der Versicherungsnehmer regelmässige Beiträge zahlt, bevor Leistungen in Anspruch genommen werden können." },
        ]
      }
    },
    decls: {
      vag45: {
        content: [],
        name: "Beraterinformationen VAG45",
        link: "assets/KundenbriefVAG_De_V03.05.pdf"
      },
      smokerStatus: {
        content: [
          "<div class=\"flex items-start text-body\"> Ausgewählt während dem Gespräch mit Ihrem Kundenberater: </div> <div class=\"w-full inline-flex flex-row items-center items-center\"> <EmptyCircle class=\"w-6 h-8 stroke-2 mr-2\" /> <div class=\"flex-1 text-base\">Ja, regelmässig</div> </div> <div class=\"w-full inline-flex flex-row items-center items-center\"> <EmptyCircle class=\"w-6 h-8 stroke-2 mr-2\" /> <div class=\"flex-1 text-base\">Ja, gelegentlich</div> </div> <div class=\"w-full inline-flex flex-row items-center items-center\"> <CheckCircle class=\"w-6 h-8 stroke-2 mr-2\" /> <div class=\"flex-1 text-base\"><b>Nein. Ich habe in den letzten 12 Monaten keine Tabak oder Tabakersatzprodukte* konsumiert.</b></div> </div> <div class=\"flex items-start text-body\"> *Darunter fallen: Zigaretten oder Zigarillos, Zigarren, Pfeife, elektronische Zigaretten, Kau- oder Schnupftabak, Nikotin Gum / Patch oder Wasserpfeife (Shisha) </div>"
        ],
        name: "Konsumieren Sie Tabak oder Tabakersatzprodukte?",
      },
      declarationOfAccession: {
        content: [
          "Ich bin zwischen 18 und 60 Jahre alt, nicht pensioniert und habe meinen Hauptwohnsitz in der Schweiz.",
          "Ich habe eine unbefristete, ungekündigte Festanstellung und arbeite mehr als 20 Stunden pro Woche bei einem Arbeitgeber oder ich bin Selbständig Erwerbend. Beim Arbeitsvertrag handelt es sich um eine feste und bezahlte Beschäftigung in der Schweiz.",
          "Ich nehme zur Kenntnis, dass der Versicherungsschutz erst nach Ablauf der in den AVB genannten Fristen besteht.",
          "Mir ist insbesondere bekannt, dass Vorerkrankungen und bestehende Leiden von der Deckung der Arbeitsunfähigkeit ausgeschlossen sein können. Der Versicherungsschutz bei vollständiger Arbeitsunfähigkeit erstreckt sich nicht auf Ansprüche (Vorerkrankungen), die auf eine bereits bestehende Arbeitsunfähigkeit oder auf bestehende Leiden (insbesondere Krankheiten oder Unfälle) zwei Jahre vor Versicherungsbeginn zurückzuführen sind, welche mir bereits heute bekannt sind oder hätten bekannt sein müssen.",
          "Mir ist bewusst, dass ich als Selbständigerwerbender und Geschäftsinhaber etc. kein Versicherungsschutz für Arbeitslosigkeit habe. Gleiches gilt für geschäftsführende Teilhaber eines Unternehmens und leitende Angestellte in «arbeitgeberähnlichen Stellung», welche aufgrund ihrer besonderen Stellung im Betrieb kein Anspruch auf Arbeitslosenleistungen haben.",
        ],
        name: "Beitrittserklärung"
      },
      gtc: {
        content: [
          "Bitte öffnen Sie den Link zu den <a href=\"assets/AVB_DE.pdf\" class=\"underline underline-offset-1\" target=\"_blank\">AVB</a> und bestätigen Sie, den Inhalt des Dokumentes gelesen und verstanden zu haben:"
        ],
        name: "Allg. Versicherungsbedingungen",
        link: "assets/AVB_De.zip"
      },
      gtcDI: {
        content: [
          "Bitte öffnen Sie den Link zu den <a href=\"assets/AVB_DI_De.pdf\" class=\"underline underline-offset-1\" target=\"_blank\">AVB</a> und bestätigen Sie, den Inhalt des Dokumentes gelesen und verstanden zu haben:"
        ],
        name: "Allg. Versicherungsbedingungen",
        link: "assets/AVB_DI_De.pdf"
      },
      gtcPPI: {
        content: [
          "Bitte öffnen Sie den Link zu den <a href=\"assets/AVB_PP_De.pdf\" class=\"underline underline-offset-1\" target=\"_blank\">AVB</a> und bestätigen Sie, den Inhalt des Dokumentes gelesen und verstanden zu haben:"
        ],
        name: "Allg. Versicherungsbedingungen",
        link: "assets/AVB_PP_De.pdf"
      },
      healthDeclaration: {
        content: [
          "Ich habe bezogen auf die nachfolgend genannten Beschwerden noch nie einen medizinischen Rat oder eine Behandlung erhalten:<ul class=\"list-inside list-[lower-alpha]\" style=\"margin-left: 10px;\"><li>Angina Pectoris, Herzinfarkt, ischämische Herzkrankheit, Schlaganfall oder Diabetes (ausgenommen Schwangerschafts - und schwangerschaftsbedingter Diabetes)</li> <li>Krebs, Melanom, Tumor oder bösartige Erkrankung oder bösartiger Tumor</li></ul>",
          "In den letzten 6 Monaten war ich insgesamt nicht mehr als drei Tage krankgeschrieben oder im Krankenhaus, und ich habe in dieser Zeit auch keine Erkrankung erlitten, für welche mir eine fachärztliche Nachuntersuchung* empfohlen oder ich eine solche in Anspruch genommen habe",
          "In den letzten 6 Monaten wurden mir keine diagnostischen Tests, Verfahren, Vorsorgeuntersuchungen, Krankenhausaufenthalte oder Operationen empfohlen, und ich warte auf keine Ergebnisse von Tests oder Untersuchungen*.<br><br><small>* Routinemässige Konsultationen im Zusammenhang mit Schwangerschaft können Sie ignorieren, Erkältung und Grippe, Routineuntersuchungen des altersbedingten Seh- und Hörvermögens sowie Vorsorgeuntersuchungs-Programme der Gesundheitsbehörden, bei denen die Ergebnisse negativ waren.</small>",
        ],
        name: "Gesundheitsdeklaration"
      },
      powerOfAttorney: {
        content: [
          "Ich ermächtige die AXA Leben AG, zur Feststellung der Leistungspflicht im Todesfall nötigenfalls Auskünfte einzuholen, bei anderen AXA-Gesellschaften, anderen Versicherungseinrichtungen, bei Amtsstellen sowie insbesondere bei Ärzten, Therapeuten, Kliniken, Pflegeeinrichtungen, Arbeitgebern, Pensions- und Krankenkassen, Vorsorge- und Freizügigkeitseinrichtungen, Ausgleichskassen, der Eidg. Invalidenversicherung sowie bei anderen Personen und Stellen, die über sachdienliche Informationen verfügen, und im erforderlichen Ausmass Personendaten weiterzugeben an Rückversicherer sowie an andere Versicherungseinrichtungen, die der AXA Gruppe angehören, und entbinde die obengenannten Personen und Stellen von der Schweigepflicht. Diese Entbindung von der Schweigepflicht gilt ausdrücklich über den Tod hinaus.",
          "Darüber hinaus ermächtige ich die {bankName}, der AXA den Versicherungsfall zu melden sowie die für die Bearbeitung des Leistungsfalles notwendigen Dokumente (wie z.B. den amtlichen Todesschein) und Informationen zu den begünstigten Personen an die AXA weiterzuleiten. Die AXA ist ermächtigt, diese Dokumente und Informationen bei der {bankName} einzuholen."
        ],
        name: "Vollmachtserklärung"
      }
    },
    description: "Deutsch",
    error: {
      atLeast1LowercaseLetter: "Mindestens 1 Kleinbuchstaben",
      atLeast1Numeral: "Mindestens 1 Ziffer (0-9)",
      atLeast1SpecialChar: "Mindestens 1 Sonderzeichen (!@#$%^&*()-_+.)",
      atLeast1UppercaseLetter: "Mindestens 1 Großbuchstaben",
      atLeast8CharsLong: "Mindestens 8 Zeichen",
      codeRequired: "Code erforderlich",
      confirmPasswordIsRequired: "Passwort bestätigen ist erforderlich",
      newPasswordIsRequired: "Neues Passwort ist erforderlich",
      passwordsMustMatch: "Passwörter müssen übereinstimmen",
    },
    isDefault: true,
    label: {
      smokerStatusIsTruthful: "Ich bestätige, dass diese Aussage der Wahrheit entspricht",
      aboveInformationIsTruthful: "Die oben stehenden Angaben entsprechen nach bestem Wissen und Gewissen der Wahrheit.",
      accountHolderName: "Name des Kontoinhabers",
      address1: "Adresszeile 1",
      address2: "Adresszeile 2",
      annual: "Jährlich",
      bankName: "Bankname",
      bankPostalCode: "Bank PLZ",
      byCheckingBoxReadUnderstoodTermsAndConditions: "Hiermit bestätige ich die Richtigkeit und Vollständigkeit meiner Angaben in diesem Antrag",
      city: "Stadt",
      confirmationPending: "Bestätigung ausstehend",
      confirmed: "Bestätigt",
      confirmPassword: "Bestätigen Sie das Passwort",
      contractNumber: "Vertragsnummer",
      coverageAmountDI: "Todesfallkapital",
      coverageAmountPPI: "Versicherte monatliche Rate",
      coverageTotal: "Deckung",
      coveragePerMonth: "Versicherte Rate pro Monat",
      customerType: "Kundentyp",
      dateOfEvent: "Ereignisdatum",
      desiredPaymentFrequency: "Gewünschte Zahlungsfrequenz",
      dueBy: "Fälligkeitsdatum",
      durationOfInsurance: "Dauer Versicherungsschutz",
      email: "E-Mail",
      firstName: "Vorname",
      grossPrice: "Rechnungsbetrag",
      halfYearly: "Halbjährlich",
      iban: "IBAN",
      incapacityForWorkAccident: "Arbeitsunfähigkeit infolge Unfall",
      incapacityForWorkIllness: "Arbeitsunfähigkeit infolge Krankheit",
      incidentDate: "Datum des Vorfalls",
      insuranceEvent: "Versicherungsfall",
      invoiceNumber: "Rechnungsnummer",
      issuedAt: "Ausstellungsdatum",
      lastName: "Familienname",
      monthly: "Monatlich",
      newPassword: "Neues Passwort",
      offeredBy: "Angeboten von",
      paidAt: "Zahlungsdatum",
      payment: "Zahlung",
      phone: "Telefonnummer",
      policyNumber: "Versicherungsnummer",
      postalCode: "PLZ",
      premium: "Jahresprämie",
      premiumPerMonth: "Prämie pro Monat",
      costPerMonth: "Kosten pro Monat",
      premiumPerQuarter: "Kosten pro Quartal",
      premiumPerYear: "Kosten pro Jahr",
      serviceFees: "Monatliche Gebühr für quartalsweise Zahlung",
      quarterly: "Quartalsweise",
      resetPassword: "Passwort zurücksetzen",
      startDate: "Startdatum",
      status: "Status",
      subStatus: "Substatus",
      total: "Gesamt",
      totalPremiumPerMonth: "Kosten pro Monat",
      unemployment: "Arbeitslosigkeit",
      validFrom: "Gültig ab",
      validTo: "Gültig bis",
      yearly: "Jährlich",
      yourCode: "Ihr Code",
      yourEmail: "Ihre E-Mail-Adresse",
      yourPassword: "Ihr Passwort",
      searchFaq: "Suche",
      dataprotectionprovisionslink: "<a href=\"https://www.axa.ch/de/informationen/datenschutz.html\" class=\"underline\" target=\"_blank\">Datenschutzbestimmungen</a>"
    },
    menu: {
      activateAccount: "Benutzerkonto aktivieren",
      cart: "Einkaufswagen",
      claim: "Schaden",
      contactRM: "Kundenberater:in kontaktieren",
      installments: "Raten",
      insurance: "Versicherung",
      insuranceCancellation: "Versicherung widerrufen",
      invoices: "Rechnungen",
      login: "Anmeldung",
      logout: "Ausloggen",
      messages: "Briefkasten",
      orderOfBeneficiaries: "Reihenfolge der Begünstigten",
      outstandingInvoices: "Ausstehende Rechnungen",
      policies: "Versicherungspolicen",
      profile: "Kundendaten",
      reportClaim: "Schaden melden",
      support: "Support"
    },
    noData: {
      activePolicies: "Keine aktiven Versicherungspolicen anzuzeigen.",
      claims: "Keine Schadensmeldungen vorhanden."
    },
    notice: {
      areYouSureYouWantCancelInsurance: "Sind Sie sicher, dass Sie Ihre Versicherung kündigen möchten?",
      areYouSureYouWantExerciseRightOfCancellation: "Sind Sie sicher, dass Sie von Ihrem Widerrufsrecht Gebrauch machen wollen?",
      changeSuccessful: "Änderung erfolgreich",
      chooseOrderOfBeneficiariesForDeathInsurance: "Wählen Sie die Reihenfolge der Begünstigten für Ihre Todesfallversicherung:",
      ifInformationIsIncorrectPleaseContactRm: "Sollten die Angaben nicht korrekt sein, wenden Sie sich bitte an Ihren Kundenberater:in.",
      insuranceEndsOn: "Der Versicherungsschutz endet am:",
      pleaseCheckEmail: "Bitte prüfen Sie Ihr E-Mail-Postfach, um Ihr Passwort zurückzusetzen.",
      pleaseCheckPersonalInformation: "Bitte prüfen Sie Ihre persönlichen Angaben. (Korrektur kann nicht selbst vorgenommen werden)",
      pleaseContactYourAdvisor: "Bitte wenden Sie sich an Ihren Kundenberater.",
      pleaseEnterCodeWeSentToNumber: "Bitte geben Sie den Code ein, den wir auf {0} gesendet haben.",
      pleaseVerifyMobileNumber: "Bitte verifizieren Sie Ihre Mobilnummer",
      resendSms: "SMS noch einmal senden",
      sinceWhenAreYouDisabled: "Seit wann sind Sie arbeitsunfähig?",
      somethingWentWrongPleaseTryAgain: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
      success: "Erfolgreich!",
      thankYouFindYourClaimHere: "Vielen Dank, dass Sie sich die Zeit genommen haben. Ihre Schadenmeldung finden Sie in Ihrem Kunden-Dashboard unter <b>Schaden</b>.",
      thankYouForApplicationFindYourConfirmation: "Vielen Dank für Ihr Beitrittsgesuch. Die entsprechende Beitrittsbestätigung finden Sie bei Ihren <a href=\"/insurance\" style=\"font-weight: 500; text-decoration: underline;\">Dokumenten</a>.",
      thankYouYouCanNowSubmitMembershipApplication: "Vielen Dank! Sie können Ihr(e) Beitrittsgesuch(e) jetzt einreichen.",
      whenDoesYourEmploymentEnd: "Wann endet Ihr Arbeitsverhältnis?",
      youAreCancellingInsuranceRetroactivelyPleaseNoteCancellationTakesEffectImmediately: "Sie sind dabei das Versicherungsverhältnis rückwirkend per Versicherungsbeginn zu annullieren. Bitte beachten Sie, dass der Widerruf sofort und unwiderruflich wirksam wird.",
      youAreInTheProcessOfCancellingInsurancePleaseNoteEndOfInsuranceTermListedBelow: "Sie sind dabei, die von Ihnen gewählte Versicherung zu kündigen. Bitte beachten Sie, dass das Laufzeitende der Versicherung unten aufgeführt ist.",
      youHaveSuccessfullySubmittedYourClaimAxaWillContactYou: "Sie haben Ihren Versicherungsfall erfolgreich eingereicht. Die AXA wird sich bei Ihnen via E-Mail melden.",
      yourClaimHasBeenSubmitted: "Ihr Schadensmeldung wurde eingereicht",
      yourProductIsActivated: "Bestätigung",
      yearlyDiscount: "Hinweis: Der Servicedienstleister (Additiv AG) erhebt eine Administrationsgebühr von CHF 20.- pro Quartal, welche nicht Bestandteil der Versicherungsprämie ist.",
    },
    policy: {
      additionalDocumentApprovals: "Bitte nehmen Sie folgende Inhalte zur Kenntnis:",
      installment: "Rechnungsbetrag",
      installmentXOutOfY: "Rate {0} von {1}",
      noDocuments: "Keine sichtbaren Dokumente zum Anzeigen.",
      noInstallments: "Keine Versicherungsraten anzuzeigen.",
      policyStart: "Start Deckung",
      yourDocuments: "Ihre Dokumente"
    },
    products: {
      DI: {
        description: "Für die Absicherung ihrer Liebsten",
        name: "Todesfallversicherung",
        customName: "Todesfallversicherung"
      },
      PPI: {
        description: "Um die Auszahlung des Kredits sicherzustellen",
        name: "Zahlungsschutzversicherung",
        customName: "Zahlungsschutzversicherung"
      }
    },
    smoker: {
      noIHaveNotConsumedTobaccoInLast12Months: "Nein. Ich habe in den letzten 12 Monaten keine Tabak oder Tabakersatzprodukte* konsumiert.",
      selectedDuringTheMeetingWithAccountManager: "Ausgewählt während dem Gespräch mit Ihrem Kundenberater:",
      thisIncludesCigarettesEtAl: "* Darunter fallen: Zigaretten oder Zigarillos, Zigarren, Pfeife, elektronische Zigaretten, Kau- oder Schnupftabak, Nikotin Gum / Patch oder Wasserpfeife (Shisha)",
      yesOccasionally: "Ja, gelegentlich",
      yesRegularly: "Ja, regelmässig",
    },
    title: {
      bankDetails: "Bankdaten",
      cancelInsurance: "Versicherungspolice widerrufen",
      cart: "Einkaufswagen",
      choosePolicy: "Versicherungspolice auswählen",
      claimDetails: "Details der Schadensmeldung",
      confirmNewPassword: "Neues Passwort bestätigen",
      insuranceDamage: "Ihre Versicherungsansprüche",
      invoices: "Rechnungen",
      login: "Anmelden",
      orderOfBeneficiaries: "Reihenfolge der Begünstigten",
      pleaseReadAndConfirmPrivacyPolicy: "Bitte lesen und bestätigen Sie die Datenschutzbestimmungen",
      provisionalQuote: "Provisorische Offerte",
      resetPassword: "Passwort zurücksetzen",
      setPasswordForYourPersonalArea: "Legen Sie ein Passwort für Ihren persönlichen Kundenbereich fest",
      summary: "Abschluss",
      welcome: "Willkommen",
      welcomeJohnDoe: "Willkommen, {0}",
      yourActivePolicies: "Ihre Versicherungen",
      yourActivePolicy: "Ihre Versicherung",
      yourActiveProducts: "Ihre Versicherung(en)",
      yourOffers: "Offerte(n)",
      yourOffersAccepted: "Ihre Versicherung(en)",
      yourBroker: "Ihr Kundenberater"
    }
  },
  fr: {
    auth: {
      downloadAuthenticatorApps: "Téléchargez une application d’authentification à deux facteurs telle que Microsoft Authenticator: {0} et {1}, ou Google Authenticator pour {2} et {3}.",
      downloadMicrosoftAuthenticator: "Téléchargez une application d’authentification à deux facteurs comme Microsoft Authenticator pour",
      enterCodeYouReceived: "Entrez le code que vous avez reçu",
      intoYourTfaApp: "dans votre application d’authentification à deux facteurs. Les espaces et les majuscules ne sont pas importants.",
      orEnterThisKey: "ou entrez ce code",
      orGoogleAuthenticator: "ou Google Authenticator pour",
      scanQrCodeBelow: "Scannez le code QR ci-dessous:",
      scanQrCodeOrEnterKey: "Scannez le code QR ou entrez ce code",
      scanQrCodeOrEnterKeyIntoTfaApp: "Scannez le code QR ou saisissez ce code {0} dans votre application d’authentification à deux facteurs. Les espaces et la casse ne sont pas importants.",
      toUseAuthAppFollowSteps: "Pour utiliser une application d’authentification, procédez comme suit:",
      wrongCredentials: "Le nom d’utilisateur ou le mot de passe n’est pas correct.",
      invalidTfaCode: "Le code saisi est invalide. Veuillez le vérifier et réessayer, ou demander un nouveau code si nécessaire.",
      accountLocked: "Nous regrettons de vous informer que votre compte a été verrouillé en raison de préoccupations de sécurité récentes. Si vous avez besoin de plus d’informations ou d’assistance, veuillez contacter notre équipe de support dans les plus brefs délais."
    },
    benefModels: {
      partnership: {
        name: "Modèle «Partenariat»",
        order: [
          "Débiteur hypothécaire survivant, à défaut de",
          "Conjoint, à défaut de",
          "Autres héritiers"
        ]
      },
      alternative: {
        name: "Modèle «Alternatif»",
        order: [
          "Conjoint ou partenaire enregistré, à défaut de",
          "Autres héritiers"
        ]
      }
    },
    btn: {
      backToLogin: "Retour à la connexion",
      cancel: "Annuler",
      complete: "Finaliser",
      confirm: "Confirmer",
      confirmDetails: "Confirmer les informations",
      confirmPassword: "Confirmer le mot de passe",
      edit: "Modifier",
      forgotPassword: "Mot de passe oublié?",
      iAgree: "Je suis d’accord",
      iDoNotAgree: "Je ne suis pas d’accord",
      learnMore: "En savoir plus",
      logIn: "Se connecter",
      refuse: "Refuser",
      resetPassword: "Réinitialiser le mot de passe",
      skipProduct: "Passer",
      submit: "Soumettre",
      submitApplication: "Soumettre la demande",
      updateProfile: "Mettre à jour le profil",
      yesCancel: "Oui, annuler",
      callBroker: "Appeler le courtier"
    },
    code: "fr",
    common: {
      and: "et",
      loading: "Chargement...",
      next: "Suivant",
      no: "Non",
      ok: "D’accord",
      outOf: "de",
      until: "jusqu’à",
      yes: "Oui",
      your: "Votre"
    },
    dataProtec: {
      communication: "Communication",
      dataProtectionProvisions: "Dispositions relatives à la protection des données",
      paragraph1: "Madame, // Monsieur,<br/><br/> Dans les pages suivantes, vous trouverez un récapitulatif des informations fournies ainsi que de la solution d’assurance choisie. Nous vous prions de bien vouloir vérifier vos informations. <br/><br/> Les données personnelles confiées et communiquées à la UKB dans le cadre de cette transmission sont traitées en toute confidentialité par cette dernière. Elles sont utilisées par la UKB et transmises à AXA et à d’autres tiers autorisés dans le cadre exclusif de la présente transmission. <br/><br/> Pour en savoir plus sur le traitement des données par chacune des parties, rendez-vous ici: <br/> <br/> UKB soc. coopérative <a href=\"https://postfinance.ch/dpd\" class=\"underline\" target=\"_blank\">https://www.postfinance.ch/fr/detail/protection-des-donnees/declaration-generale-de-protection-des-donnees.html</a> <br/> AXA Assurances SA / AXA Vie SA <a href=\"https://www.axa.ch/fr/informations/protection-donnees.html\" class=\"underline\" target=\"_blank\">https://www.axa.ch/fr/informations/protection-donnees.html</a> <br/>",
      paragraph2: "En souscrivant, vous confirmez que les données fournies sont exactes et complètes. Par ailleurs, vous confirmez avoir libéré la UKB de l’obligation de confidentialité et du secret bancaire au moyen du formulaire déjà signé et accepter la transmission de vos données. Veuillez également noter que vos informations peuvent vous être transmises de manière non cryptée.",
      usingTheWebsite: "Utilisation du site Web"
    },
    faq: {
      DI: {
        title: "Assurance en cas de décès",
        docName: "Factsheet",
        link: "assets/Factsheet_TodesfallVersicherung_Fr.pdf",
        faqs: [
          { "q": "Was ist die 'Todesfallversicherung' für eine Versicherung?", "a": "Die Todesfallversicherung ist eine reine Risiko-Lebensversicherung. Ein Todesfall bringt das Leben der Hinterbliebenen aus dem Gleichgewicht. Es fallen hohe Kosten an und es fällt ein Einkommen plötzlich aus. Die Kapitalauszahlung schützt die Angehörigen vor einer grossen finanziellen Belastung und sichert die Finanzierung der Lebenskosten." },
          { "q": "Wer kann eine Hypothekar-Todesfallversicherung abschliessen?", "a": "Eine natürliche Person muss folgende generelle Kriterien für den Beitritt in den Kollektivversicherungsvertrag erfüllen: <ul class=\"list-inside ml-2 list-[lower-alpha]\" ><li>in der Schweiz wohnhaft (die Enklaven auf Schweizer Territorium werden hier nicht dazugezählt)</li><li>zwischen 18 und 60 Jahre alt sein</li><li>darf keine US Person sein (Was ist mit Doppelbürgerschaften und Green Card?)</li><li>muss eine Hypothek bei der Post Finance abgeschlossen haben </li></ul><br/> Weiter muss der Kunde: <ul class=\"list-inside ml-2 list-[lower-alpha]\" ></ul><li>eine einfache Gesundheitsdeklaration ausfüllen</li><li>sein Rauchverhalten deklarieren</li>" },
          { "q": "Welche Deckungen können gewählt werden?", "a": "Wichtig ist, zu verstehen, dass Ihr Versicherungsschutz immer auf der Basis Ihrer Hypothek entsteht und Sie innerhalb der folgenden Parameter Ihre Deckung wählen können: <ol class=\"list-inside ml-2 list-[lower-alpha]\" ><ul>1. Der maximal wählbare Versicherungsschutz wird von der Höhe des Hypothekarbetrags abgeleitet. </ul> <ul>2. Vom Hypothekarbetrag können 100%, 75%, 50% oder 25% abgesichert werden.</ul><ul>3. Einschränkungen: Die Versicherungssumme entspricht grundsätzlich max. der Hypothekarschuld, bei Hypothekarsummen >2 Mio. entspricht das max. CHF 2 Mio., bei geringen Hypothekarsummen liegt die minimale Absicherung bei CHF 50k.</ul> <ul>4. Bei zwei Hypothekarnehmern kann der Versicherungsschutz auf die beiden Personen verteilt werden. Total darf jedoch die Höhe der Hypothek nicht überschritten werden, vgl. Punkt 3 </ul><ul>5. Die Versicherungssumme nimmt analog der geleisteten Amortisation (direkt und indirekt) ab - proportional zum gewählten %-Baustein.</ul> </ol>" },
          { "q": "Wie finde ich die passende Deckung?", "a": "Die passende Deckung hängt in erster Linie von der finanziellen Situation der Hinterbliebenen ab. Oft entstehen im Unglücksfall finanzielle Engpässe für Ihre Liebsten. Je höher die Versicherungssumme in diesem Fall, desto mehr 'Gestaltungsfreiheit' und Zeit das Leben in geordnete Bahnen zu bringen für Ihre Hinterbliebenen. Gleichzeitig bezahlen Sie für höhere Leistungen mehr Prämie. Die richtige Balance ist sehr individuell. Wir empfehlen die Leistungen aus der Pensionskasse und weiteren Versicherungen zu berücksichtigen." },
          { "q": "Bleibt die Prämie konstant über die Laufzeit?", "a": "Nein. Die Höhe der Prämie berechnet sich aus der Höhe des Todesfallkapitals, sowie dem Alter der versicherten Person. Dies bedeutet: Die Prämie wird jährlich an Ihr aktuelles Alter angepasst - sie steigt dadurch über die Vertragslaufzeit grundsätzlich an. Gleichzeitig - sofern Sie einen Amortisationsteil haben - sinkt ihr Todesfallkapital jährlich um die Amortisation und damit sinkt der Prämienteil ebenfalls. Mit Erhalt der jährlichen Versicherungsbestägigung sind Todesfallkaptial und Prämie für das nächste Verischerungsjahr ersichtlich." },
          { "q": "Was passiert im Todesfall?", "a": "Die Angehörigen melden den Todesfall dem Kundenberater. Dieser wiederumg leitet die Information an Ihren Versicherungspartner 'AXA' weiter. Folglich werden im Zusammenspiel zwischen Kundenberater und AXA die notwendigen Dokumente bei den Hinterblibenen angefordert und die Ansprüche geprüft." },
          { "q": "Wo muss ich den Todesfallschein und das Erbverzeichnis einreichen?", "a": "Nur der Todesfallschein und die Kontaktangaben der Angehörigen müssen digital via RM Claims Prozess eingereicht werden. Das Erbverzeichnis wurde bereits geklärt. Sie eröffnen hierzu einen Schadenfall für den Kunden. Dort können Sie das Dokument als pdf hochladen und an AXA senden." },
        ]
      },
      PPI: {
        title: "Assurance de protection des paiements",
        docName: "Factsheet",
        link: "assets/Factsheet_ZahlungsschutzVersicherung_Fr.pdf",
        faqs: [
          { "q": "Was ist der 'Zahlungsschutz' für eine Versicherung?", "a": "Mit der Zahlungsschutzversicherung wird der versicherte Anteil Ihrer monatlichen Hypothekarverpflichtungen während maximal 12 Monaten weiterbezahlt, wenn Sie arbeitsunfähig (Unfall/Krankheit) oder unverschuldet arbeitslos werden." },
          { "q": "Wer kann vom Zahlungsschutz profitieren?", "a": "Eine Person muss folgende generelle Kriterien für einen Versicherungsabschluss erfüllen: <ul class=\"list-inside ml-2 list-[lower-alpha]\"> <li>muss in der Schweiz wohnhaft sein (die Enklaven auf Schweizer Territorium werden hier nicht dazugezählt)</li> <li>muss zwischen 18 und 60 Jahre alt sein</li> <li>muss einen Hypothekarvertrag bei der {bank} abgeschlossen haben</li> <li>einer festen und bezahlten Beschäftigung in der Schweiz unter einem unbefristeten, ungekündigten Arbeitsvertrag nachgehen und mindestens 20 Stunden pro Woche bei demselben Arbeitgeber beschäftigt oder selbständig erwerbend sein</li> </ul>" },
          { "q": "Welche Deckungen kann ich wählen?", "a": "Abgedeckt ist der in der Versicherungsbestätigung aufgeführten Teil (40% oder 80%) der monatliche Rate der Hypothekarverpflichtungen (effektiver Hypothekarzins inkl. allfälligem Amortisationsbetrag aller von der versicherten Person bei der Post Finance im Rahmen des Hypothekarvertrages abgeschlossenen Hypothekartranchen) bei einer vollständigen Arbeitsunfähigkeit infolge Krankheit / Unfall oder einer unverschuldeten Arbeitslosigkeit." },
          { "q": "Weshalb unterscheidet sich die Prämie?", "a": "Die versicherte Rate wird jährlich den effektiven Hypothekarverpflichtungen (effektiver Hypothekarzins inkl. allfälligem Amortisationsbetrag) angepasst. Bei SARON Anteilen wird der zu dieser Zeit geltende Zinssatz verwendet." },
          { "q": "Wie melde ich einen Leistungsfall?", "a": "Sie können den Prozess ganz einfach im Kunden-Dashboard starten, indem Sie auf 'Meine Versicherungen' und dort anschliessend auf das Plus-Symbol klicken, 'Versicherungsfall melden' auswählen und den Anweisungen auf dem Bildschirm für die Zahlungsschutzversicherung folgen." },
          { "q": "Was ist eine 'Wartefrist'?", "a": "Die Wartefrist ist der Zeitraum, in dem nach einem versicherten Ereignis noch keine Leistungen bezogen werden können." },
          { "q": "Was ist eine 'Karenzfrist'?", "a": "Eine Karenzfrist bei Versicherungen bezieht sich auf einen festgelegten Zeitraum, der nach Abschluss einer Versicherungspolice verstreichen muss, bevor bestimmte Leistungen oder Deckungen in Kraft treten. Während dieser Karenzfrist können auch im Schadenfall keine Versicherungsansprüche geltend gemacht werden. Die Karenzfrist dient dazu, die Versicherung vor Missbrauch zu schützen und sicherzustellen, dass der Versicherungsnehmer regelmässige Beiträge zahlt, bevor Leistungen in Anspruch genommen werden können." },
        ]
      }
    },
    decls: {
      vag45: {
        content: [],
        name: "Informations clients selon l’art. 45 LSA",
        link: "assets/KundenbriefVAG_Fr_V03.05.pdf"
      },
      smokerStatus: { // TODO: Why is this in German?
        content: [
          "<div class=\"flex items-start text-body\"> Ausgewählt während dem Gespräch mit Ihrem Kundenberater: </div> <div class=\"w-full inline-flex flex-row items-center items-center\"> <EmptyCircle class=\"w-6 h-8 stroke-2 mr-2\" /> <div class=\"flex-1 text-base\">Ja, regelmässig</div> </div> <div class=\"w-full inline-flex flex-row items-center\"> <EmptyCircle class=\"w-6 h-8 stroke-2 mr-2\" /> <div class=\"flex-1 text-base\">Ja, gelegentlich</div> </div> <div class=\"w-full inline-flex flex-row items-center\"> <CheckCircle class=\"w-6 h-8 stroke-2 mr-2\" /> <div class=\"flex-1 text-base\"><b>Nein. Ich habe in den letzten 12 Monaten keine Tabak oder Tabakersatzprodukte* konsumiert.</b></div> </div> <div class=\"flex items-start text-body\"> *Darunter fallen: Zigaretten oder Zigarillos, Zigarren, Pfeife, elektronische Zigaretten, Kau- oder Schnupftabak, Nikotin Gum / Patch oder Wasserpfeife (Shisha) </div>"
        ],
        name: "Consommez-vous du tabac ou des produits de substitution?"
      },
      declarationOfAccession: {
        content: [
          "J’ai entre 18 et 60 ans, je ne suis pas retraité et ma résidence principale est en Suisse.",
          "J’ai un poste permanent et non terminé et je travaille plus de 20 heures par semaine pour un employeur ou je suis indépendant. Le contrat de travail est un emploi permanent et rémunéré en Suisse.",
          "Je reconnais que la couverture d’assurance ne s’applique qu’après l’expiration des délais précisés dans les Conditions Générales.",
          "Je suis particulièrement conscient que les maladies antérieures et les maladies existantes peuvent être exclues de la couverture d’incapacité de travail. La couverture d’assurance en cas d’incapacité totale de travail ne s’étend pas aux sinistres (maladies préexistantes) dus à une incapacité de travail existante ou à des maladies existantes (en particulier maladies ou accidents) deux ans avant le début de l’assurance, qui me sont déjà connus aujourd’hui ou auraient dû l’être.",
          "Je suis conscient qu’en tant qu’indépendant, chef d’entreprise, etc., je n’ai aucune couverture d’assurance-chômage. Il en va de même pour les associés-gérants d’une entreprise et les salariés seniors occupant des «postes assimilés à ceux d’un employeur» qui n’ont pas droit aux allocations de chômage en raison de leur position particulière dans l’entreprise."
        ],
        name: "Déclaration d’adhésion"
      },
      gtc: {
        content: [
          "Veuillez ouvrir le lien vers les conditions générales d’assurance (CGA) et confirmer que vous avez lu et compris le contenu du document:"
        ],
        name: "Conditions générales d’assurance",
        link: "assets/CGA.zip"
      },
      gtcDI: {
        content: [
          "Veuillez ouvrir le lien vers les conditions générales d’assurance <a href=\"assets/CGA_DI.pdf\" class=\"underline underline-offset-4\" target=\"_blank\">(CGA)</a> et confirmer que vous avez lu et compris le contenu du document:"
        ],
        name: "Conditions générales d’assurance (CGA)",
        link: "assets/CGA_DI.pdf"
      },
      gtcPPI: {
        content: [
          "Veuillez ouvrir le lien vers les conditions générales d’assurance <a href=\"assets/CGA_PP.pdf\" class=\"underline underline-offset-4\" target=\"_blank\">(CGA)</a> et confirmer que vous avez lu et compris le contenu du document:"
        ],
        name: "Conditions générales d’assurance (CGA)",
        link: "assets/CGA_PP.pdf"
      },
      healthDeclaration: {
        content: [
          "Je n’ai jamais consulté de médecin ou suivi un traitement médical en rapport avec les affections suivantes:<ul class=\"list-inside list-[lower-alpha]\" style=\"margin-left: 10px;\"><li>Angine de poitrine, infarctus, cardiopathie ischémique, accident vasculaire cérébral ou diabète (hors diabète gestationnel et en lien avec la grossesse)</li> <li>Cancer, mélanome, tumeur ou pathologie/tumeur maligne</li></ul>",
          "Au cours des six derniers mois, je n’ai pas eu plus de trois jours de congé maladie ou d’hospitalisation au total, et je n’ai pas non plus contracté de maladie pendant cette période, pour laquelle un examen par un médecin spécialiste m’a été recommandé ou que j’ai sollicité moi-même",
          "Au cours des six derniers mois, aucun examen diagnostique, aucune procédure, aucun examen préventif, aucune hospitalisation ni opération ne m’ont été recommandés, et je n’attends aucun résultat de tests ou d’examens*.<br><br><small>* Veuillez ignorer toutes les consultations usuelles en lien avec une grossesse, un refroidissement et une grippe, ainsi que les tests routiniers d’aptitude visuelle et auditive liés à l’âge et les programmes de prévention des autorités sanitaires dont les résultats sont négatifs.</small>"
        ],
        name: "Déclaration de santé"
      },
      powerOfAttorney: {
        content: [
          "J’autorise AXA Vie SA à se procurer, pour déterminer son obligation de verser des prestations en cas de décès, des renseignements auprès d’autres sociétés AXA, d’autres institutions d’assurance, des services administratifs ainsi que, en particulier, des médecins, thérapeutes, cliniques, institutions de soins, employeurs, caisses de pension et caisses-maladie, institutions de prévoyance et de libre passage, caisses de compensation, l’assuranceinvalidité fédérale ainsi qu’auprès d’autres personnes et instances disposant des informations nécessaires, de même qu’à transmettre, dans la mesure requise, des données personnelles à des réassureurs et à d’autres institutions d’assurance appartenant au Groupe AXA, et je délie les personnes et les services susmentionnés de leur obligation de garder le secret. Cette libération de l’obligation de garder le secret demeure expressément valable au-delà du décès.",
          "En outre, j’autorise AXA Vie SA à demander des informations et des documents complémentaires, par exemple l’acte de décès, auprès de UKB soc. coopérative."
        ],
        name: "Déclaration de procuration"
      }
    },
    description: "Français",
    error: {
      atLeast1LowercaseLetter: "Au moins 1 lettre minuscule",
      atLeast1Numeral: "Au moins 1 chiffre (0-9)",
      atLeast1SpecialChar: "Au moins 1 caractère spécial (!@#$%^&*()-_+.)",
      atLeast1UppercaseLetter: "Au moins 1 lettre majuscule",
      atLeast8CharsLong: "Au moins 8 caractères",
      codeRequired: "Code requis",
      confirmPasswordIsRequired: "Confirmation du mot de passe est requise",
      newPasswordIsRequired: "Nouveau mot de passe est requis",
      passwordsMustMatch: "Mots de passe doivent correspondre",
    },
    isDefault: false,
    label: {
      smokerStatusIsTruthful: "Je confirme que cette déclaration est vraie.",
      aboveInformationIsTruthful: "Les informations ci-dessus sont véridiques au meilleur de ma connaissance.",
      accountHolderName: "Nom du titulaire du compte",
      address1: "Adresse ligne 1",
      address2: "Adresse ligne 2",
      annual: "Annuelle",
      bankName: "Nom de banque",
      bankPostalCode: "Code postal de banque",
      byCheckingBoxReadUnderstoodTermsAndConditions: "En cochant cette case, je confirme avoir lu et compris les conditions générales.",
      city: "Ville",
      confirmationPending: "Confirmation en attente",
      confirmed: "Confirmé",
      confirmPassword: "Confirmez le mot de passe",
      contractNumber: "Numéro de contrat",
      coverageAmountDI: "Capital-décès",
      coverageAmountPPI: "Mensualité assurée",
      coverageTotal: "Couverture",
      coveragePerMonth: "Couverture par mois",
      customerType: "Type de client",
      dateOfEvent: "Date de l’événement",
      desiredPaymentFrequency: "Fréquence de paiement souhaitée",
      dueBy: "Date d’échéance",
      durationOfInsurance: "Durée de la couverture d’assurance",
      email: "E-mail",
      firstName: "Prénom",
      grossPrice: "Prix brut",
      halfYearly: "Semestriel",
      iban: "IBAN",
      incapacityForWorkAccident: "Incapacité de travailler suite à un accident",
      incapacityForWorkIllness: "Incapacité de travailler pour cause de maladie",
      incidentDate: "Date de l’incident",
      insuranceEvent: "Événement d’assurance",
      invoiceNumber: "Numéro de facture",
      issuedAt: "Date d’émission",
      lastName: "Nom de famille",
      monthly: "Mensuel",
      newPassword: "Nouveau mot de passe",
      offeredBy: "Offert par",
      paidAt: "Date de paiement",
      payment: "Paiement",
      phone: "Numéro de téléphone",
      policyNumber: "Numéro de police d’assurance",
      postalCode: "Code postal",
      premium: "Prime",
      premiumPerMonth: "Prime par mois",
      costPerMonth: "Coût par mois",
      premiumPerQuarter: "Coût par trimestre",
      premiumPerYear: "Coût par an",
      serviceFees: "Frais mensuels pour paiement trimestriel",
      quarterly: "Trimestrielle",
      resetPassword: "Réinitialiser mot de passe",
      startDate: "Date de début",
      status: "Statut",
      subStatus: "Sous-statut",
      total: "Au total",
      totalPremiumPerMonth: "Prime totale par mois",
      unemployment: "Chômage",
      validFrom: "Valable à partir du",
      validTo: "Valide jusqu’à", // TODO: Valable?
      yearly: "Annuelle",
      yourCode: "Votre code",
      yourEmail: "Votre e-mail",
      yourPassword: "Votre mot de passe",
      searchFaq: "Recherche",
      dataprotectionprovisionslink: "<a href=\"https://www.axa.ch/fr/informations/protection-donnees.html\" class=\"underline\" target=\"_blank\">Dispositions relatives à la protection des données</a>"
    },
    menu: {
      activateAccount: "Activation du compte",
      cart: "Panier",
      claim: "Sinistres",
      contactRM: "Contacter votre conseillère ou conseiller",
      installments: "Versements",
      insurance: "Assurance",
      insuranceCancellation: "Résilier l’assurance",
      invoices: "Factures",
      login: "Connexion",
      logout: "Déconnexion",
      messages: "Boites aux lettres",
      orderOfBeneficiaries: "Ordre des bénéficiaires",
      outstandingInvoices: "Factures en attente",
      policies: "Polices",
      profile: "Données client",
      reportClaim: "Soumettre sinistres",
      support: "Assistance"
    },
    noData: {
      activePolicies: "Aucune police d’assurance active à afficher.",
      claims: "Aucun dommage signalé.",
    },
    notice: {
      areYouSureYouWantCancelInsurance: "Etes-vous sûr de vouloir résilier votre assurance?",
      areYouSureYouWantExerciseRightOfCancellation: "Etes-vous sûr de vouloir exercer votre droit de rétractation?",
      changeSuccessful: "Changement réussi",
      chooseOrderOfBeneficiariesForDeathInsurance: "Choisissez l’ordre des bénéficiaires de votre assurance décès:",
      ifInformationIsIncorrectPleaseContactRm: "Si ces données sont inexactes, veuillez contacter votre conseiller à la clientèle.",
      insuranceEndsOn: "La couverture d’assurance prend fin:",
      pleaseCheckEmail: "Veuillez vérifier votre boîte de réception e-mail pour réinitialiser votre mot de passe.",
      pleaseCheckPersonalInformation: "Veuillez vérifier vos données personnelles et les corriger si nécessaire.",
      pleaseContactYourAdvisor: "Veuillez contacter votre conseiller à la clientèle.",
      pleaseEnterCodeWeSentToNumber: "Veuillez saisir le code que nous avons envoyé à {0}.",
      pleaseVerifyMobileNumber: "Veuillez vérifier votre numéro de mobile",
      resendSms: "Envoyez à nouveau des SMS",
      sinceWhenAreYouDisabled: "Depuis quand êtes-vous inapte au travail?",
      somethingWentWrongPleaseTryAgain: "Une erreur s’est produite. Veuillez réessayer",
      success: "Succès!",
      thankYouFindYourClaimHere: "Merci d’avoir pris le temps. Vous pouvez trouver votre rapport de réclamation dans votre tableau de bord client sous <b>Réclamation</b>.",
      thankYouForApplicationFindYourConfirmation: "Vous pouvez consulter votre offre à tout moment dans votre compte personnel. Nous vous enverrons également l’accès au compte client sur votre email.",
      thankYouYouCanNowSubmitMembershipApplication: "Merci beaucoup. Vous pouvez déposer votre demande resp. vos demandes d’adhésion dès maintenant.",
      whenDoesYourEmploymentEnd: "Quand votre contrat de travail prend-il fin?",
      youAreCancellingInsuranceRetroactivelyPleaseNoteCancellationTakesEffectImmediately: "Vous êtes en train de résilier le rapport d’assurance avec effet rétroactif dès le début de l’assurance. Veuillez noter que la révocation prend effet immédiatement et irrévocablement.",
      youAreInTheProcessOfCancellingInsurancePleaseNoteEndOfInsuranceTermListedBelow: "Vous êtes sur le point de résilier l’assurance que vous avez choisie. Veuillez noter que la fin de la durée d’assurance est indiquée ci-dessous.",
      youHaveSuccessfullySubmittedYourClaimAxaWillContactYou: "Vous avez soumis avec succès votre réclamation d’assurance. AXA vous contactera par email.",
      yourClaimHasBeenSubmitted: "Votre réclamation a été soumise",
      yourProductIsActivated: "Votre produit est activé",
      yearlyDiscount: "Veuillez noter que notre prestataire de services (Additiv SA) vous offre une réduction de CHF 20.- par trimestre si vous choisissez la fréquence de paiement annuelle.",
    },
    policy: {
      additionalDocumentApprovals: "Veuillez lire et confirmer le contenu suivant:",
      installment: "Versement",
      installmentXOutOfY: "Versement {0} de {1}",
      noDocuments: "Aucun document visible à afficher.",
      noInstallments: "Aucun versement de police à afficher.",
      policyStart: "Début de la couverture",
      yourDocuments: "Vos documents"
    },
    products: {
      DI: {
        description: "Pour protéger vos proches",
        name: "Assurance en cas de décès",
        customName: "assurance en cas de décès",
      },
      PPI: {
        description: "Pour garantir le remboursement du prêt",
        name: "Assurance de protection des paiements",
        customName: "assurance de protection des paiements"
      }
    },
    smoker: {
      noIHaveNotConsumedTobaccoInLast12Months: "Non, Au cours des 12 derniers mois, je n’ai consommé aucun produit du tabac ou substitut nicotinique*.",
      selectedDuringTheMeetingWithAccountManager: "Sélectionné lors de l’entretien avec votre conseiller à la clientèle:",
      thisIncludesCigarettesEtAl: "* Sont compris: cigarettes ou cigarillos, cigares, pipe, cigarettes électroniques, tabac à chiquer ou à priser, gomme ou patch à la nicotine ou pipe à eau (narguilé ou chicha).",
      yesOccasionally: "Oui, occasionnellement",
      yesRegularly: "Oui, régulièrement"
    },
    title: {
      bankDetails: "Coordonnées bancaires",
      cancelInsurance: "Résilier l’assurance",
      cart: "Panier",
      choosePolicy: "Choisir la police",
      claimDetails: "Détails de la réclamation",
      confirmNewPassword: "Confirmer le nouveau mot de passe",
      insuranceDamage: "Vos réclamations d’assurance",
      invoices: "Factures",
      login: "Connexion",
      orderOfBeneficiaries: "Ordre des bénéficiaires",
      pleaseReadAndConfirmPrivacyPolicy: "Veuillez lire et confirmer la politique de confidentialité",
      provisionalQuote: "Offre provisoire",
      resetPassword: "Réinitialiser le mot de passe",
      setPasswordForYourPersonalArea: "Définissez un mot de passe pour votre espace client personnel",
      summary: "Confirmation",
      welcome: "Bienvenue",
      welcomeJohnDoe: "Bienvenue, {0}",
      yourActivePolicies: "Vos polices",
      yourActivePolicy: "Votre assurance",
      yourActiveProducts: "Vos produits actifs",
      yourOffers: "Offre(s)",
      yourOffersAccepted: "Votre(s) assurance(s)",
      yourBroker: "Votre conseiller clientèle"
    }
  },
  it: {
    auth: {
      downloadAuthenticatorApps: "Scarica un’app di autenticazione a due fattori come Microsoft Authenticator: {0} e {1} o Google Authenticator per {2} e {3}.",
      downloadMicrosoftAuthenticator: "Scarica un’app di autenticazione a due fattori come Microsoft Authenticator per",
      enterCodeYouReceived: "Inserisci il codice che hai ricevuto",
      intoYourTfaApp: "nella sua app di autenticazione a due fattori. Gli spazi e le maiuscole non sono importanti.",
      orEnterThisKey: "o inserisci questo codice",
      orGoogleAuthenticator: "o Google Authenticator per",
      scanQrCodeBelow: "Scansiona il codice QR qui sotto",
      scanQrCodeOrEnterKey: "Scansiona il codice QR o inserisci questo codice",
      scanQrCodeOrEnterKeyIntoTfaApp: "Scansiona il codice QR o inserisci questo codice <b>{0}</b> nella sua app di autenticazione a due fattori. Gli spazi e le maiuscole non sono importanti.",
      toUseAuthAppFollowSteps: "Per utilizzare un’app di autenticazione, procedi nel seguente modo:",
      wrongCredentials: "Il nome utente o la password non sono corretti.",
      invalidTfaCode: "Il codice inserito non è valido. Si prega di controllarlo e riprovare, oppure richiedere un nuovo codice se necessario.",
      accountLocked: "Nous regrettons de vous informer que votre compte a été verrouillé en raison de préoccupations de sécurité récentes. Si vous avez besoin de plus d’informations ou d’assistance, veuillez contacter notre équipe de support dans les plus brefs délais."
    },
    benefModels: {
      partnership: {
        name: "Modell «Partnerschaft»",
        order: [
          "Überlebender Hypothekarschuldner, bei dessen Fehlen",
          "Ehegatte, bei dessen Fehlen",
          "Übrige Erben"
        ]
      },
      alternative: {
        name: "Modell «Alternative»",
        order: [
          "Ehegatte oder eingetragener Partner, bei dessen Fehlen",
          "Übrige Erben"
        ]
      }
    },
    btn: {
      backToLogin: "Ritorna al login",
      cancel: "Annullare",
      complete: "Completare",
      confirm: "Confermare",
      confirmDetails: "Confermare le informazioni",
      confirmPassword: "Conferma password",
      edit: "Modificare",
      forgotPassword: "Password dimenticata?",
      iAgree: "Sono d’accordo",
      iDoNotAgree: "No sono d’accordo",
      learnMore: "",
      logIn: "Accedere",
      refuse: "",
      resetPassword: "Reimposta password",
      skipProduct: "Salta il prodotto",
      submit: "Invia",
      submitApplication: "",
      updateProfile: "Aggiorna profilo",
      yesCancel: "Sì, annulla",
      callBroker: "Chiama il consulente clienti"
    },
    code: "it",
    common: {
      and: "e",
      loading: "Caricamento...",
      next: "Ancora",
      no: "No",
      ok: "D’accordo",
      outOf: "di",
      until: "fino a",
      yes: "Sì",
      your: "Suo"
    },
    dataProtec: {
      communication: "Comunicazione",
      dataProtectionProvisions: "Disposizioni in materia di protezione dei dati",
      paragraph1: "Lieber Kund:in <br/><br/> Auf den folgenden Seiten finden Sie eine Zusammenfassung der gemachten Angaben sowie der gewählten Versicherungslösung. Wir bitten Sie, Ihre Informationen zu überprüfen. <br/><br/> Die Personendaten, welche Sie im Zusammenhang mit der vorliegenden Vermittlung PostFinance anvertrauen und bekannt geben, werden von PostFinance vertraulich behandelt und von PostFinance ausschliesslich im Rahmen der vorliegenden Vermittlung an AXA sowie weitere berechtigte Dritte weitergegeben und verwendet. <br/><br/> Über die Datenbearbeitung der jeweiligen Partei können sie sich hier informieren: <br/> <br/> PostFinance AG <a href=\"https://postfinance.ch/dse\" class=\"underline\" target=\"_blank\">https://postfinance.ch/dse</a> <br/> AXA Versicherungen AG / AXA Leben AG <a href=\"https://www.axa.ch/datenschutz\" class=\"underline\" target=\"_blank\">https://www.axa.ch/datenschutz</a> <br/>",
      paragraph2: "Mit Abschluss bestätigen Sie die Richtigkeit und Vollständigkeit der gemachten Angaben. Sie bestätigen zudem, die PostFinance von der Geheimhaltungspflicht sowie dem Bankkundengeheimnis im Rahmen des bereits unterzeichneten Entbindungsformulars entbunden zu haben und der Weitergabe Ihrer Daten zuzustimmen. Überdies bitten wir Sie zur Kenntnis zu nehmen, dass Ihre Informationen unverschlüsselt an Sie übermittelt werden können.",
      usingTheWebsite: "Utilizzo del sito"
    },
    faq: {
      DI: {
        title: "Todesfallversicherung",
        docName: "Factsheet",
        link: "assets/Factsheet_TodesfallVersicherung_De.pdf",
        faqs: [
          { "q": "Was ist die 'Todesfallversicherung' für eine Versicherung?", "a": "Die Todesfallversicherung ist eine reine Risiko-Lebensversicherung. Ein Todesfall bringt das Leben der Hinterbliebenen aus dem Gleichgewicht. Es fallen hohe Kosten an und es fällt ein Einkommen plötzlich aus. Die Kapitalauszahlung schützt die Angehörigen vor einer grossen finanziellen Belastung und sichert die Finanzierung der Lebenskosten." },
          { "q": "Wer kann eine Hypothekar-Todesfallversicherung abschliessen?", "a": "Eine natürliche Person muss folgende generelle Kriterien für den Beitritt in den Kollektivversicherungsvertrag erfüllen: <ul class=\"list-inside ml-2 list-[lower-alpha]\" ><li>in der Schweiz wohnhaft (die Enklaven auf Schweizer Territorium werden hier nicht dazugezählt)</li><li>zwischen 18 und 60 Jahre alt sein</li><li>darf keine US Person sein (Was ist mit Doppelbürgerschaften und Green Card?)</li><li>muss eine Hypothek bei der Post Finance abgeschlossen haben </li></ul><br/> Weiter muss der Kunde: <ul class=\"list-inside ml-2 list-[lower-alpha]\" ></ul><li>eine einfache Gesundheitsdeklaration ausfüllen</li><li>sein Rauchverhalten deklarieren</li>" },
          { "q": "Welche Deckungen können gewählt werden?", "a": "Wichtig ist, zu verstehen, dass Ihr Versicherungsschutz immer auf der Basis Ihrer Hypothek entsteht und Sie innerhalb der folgenden Parameter Ihre Deckung wählen können: <ol class=\"list-inside ml-2 list-[lower-alpha]\" ><ul>1. Der maximal wählbare Versicherungsschutz wird von der Höhe des Hypothekarbetrags abgeleitet. </ul> <ul>2. Vom Hypothekarbetrag können 100%, 75%, 50% oder 25% abgesichert werden.</ul><ul>3. Einschränkungen: Die Versicherungssumme entspricht grundsätzlich max. der Hypothekarschuld, bei Hypothekarsummen >2 Mio. entspricht das max. CHF 2 Mio., bei geringen Hypothekarsummen liegt die minimale Absicherung bei CHF 50k.</ul> <ul>4. Bei zwei Hypothekarnehmern kann der Versicherungsschutz auf die beiden Personen verteilt werden. Total darf jedoch die Höhe der Hypothek nicht überschritten werden, vgl. Punkt 3 </ul><ul>5. Die Versicherungssumme nimmt analog der geleisteten Amortisation (direkt und indirekt) ab - proportional zum gewählten %-Baustein.</ul> </ol>" },
          { "q": "Wie finde ich die passende Deckung?", "a": "Die passende Deckung hängt in erster Linie von der finanziellen Situation der Hinterbliebenen ab. Oft entstehen im Unglücksfall finanzielle Engpässe für Ihre Liebsten. Je höher die Versicherungssumme in diesem Fall, desto mehr 'Gestaltungsfreiheit' und Zeit das Leben in geordnete Bahnen zu bringen für Ihre Hinterbliebenen. Gleichzeitig bezahlen Sie für höhere Leistungen mehr Prämie. Die richtige Balance ist sehr individuell. Wir empfehlen die Leistungen aus der Pensionskasse und weiteren Versicherungen zu berücksichtigen." },
          { "q": "Bleibt die Prämie konstant über die Laufzeit?", "a": "Nein. Die Höhe der Prämie berechnet sich aus der Höhe des Todesfallkapitals, sowie dem Alter der versicherten Person. Dies bedeutet: Die Prämie wird jährlich an Ihr aktuelles Alter angepasst - sie steigt dadurch über die Vertragslaufzeit grundsätzlich an. Gleichzeitig - sofern Sie einen Amortisationsteil haben - sinkt ihr Todesfallkapital jährlich um die Amortisation und damit sinkt der Prämienteil ebenfalls. Mit Erhalt der jährlichen Versicherungsbestägigung sind Todesfallkaptial und Prämie für das nächste Verischerungsjahr ersichtlich." },
          { "q": "Was passiert im Todesfall?", "a": "Die Angehörigen melden den Todesfall dem Kundenberater. Dieser wiederumg leitet die Information an Ihren Versicherungspartner 'AXA' weiter. Folglich werden im Zusammenspiel zwischen Kundenberater und AXA die notwendigen Dokumente bei den Hinterblibenen angefordert und die Ansprüche geprüft." },
          { "q": "Wo muss ich den Todesfallschein und das Erbverzeichnis einreichen?", "a": "Nur der Todesfallschein und die Kontaktangaben der Angehörigen müssen digital via RM Claims Prozess eingereicht werden. Das Erbverzeichnis wurde bereits geklärt. Sie eröffnen hierzu einen Schadenfall für den Kunden. Dort können Sie das Dokument als pdf hochladen und an AXA senden." },
        ]
      },
      PPI: {
        title: "Zahlungsschutz",
        docName: "Factsheet",
        link: "assets/Factsheet_ZahlungsschutzVersicherung_De.pdf",
        faqs: [
          { "q": "Was ist der 'Zahlungsschutz' für eine Versicherung?", "a": "Mit der Zahlungsschutzversicherung wird der versicherte Anteil Ihrer monatlichen Hypothekarverpflichtungen während maximal 12 Monaten weiterbezahlt, wenn Sie arbeitsunfähig (Unfall/Krankheit) oder unverschuldet arbeitslos werden." },
          { "q": "Wer kann vom Zahlungsschutz profitieren?", "a": "Eine Person muss folgende generelle Kriterien für einen Versicherungsabschluss erfüllen: <ul class=\"list-inside ml-2 list-[lower-alpha]\"> <li>muss in der Schweiz wohnhaft sein (die Enklaven auf Schweizer Territorium werden hier nicht dazugezählt)</li> <li>muss zwischen 18 und 60 Jahre alt sein</li> <li>muss einen Hypothekarvertrag bei der {bank} abgeschlossen haben</li> <li>einer festen und bezahlten Beschäftigung in der Schweiz unter einem unbefristeten, ungekündigten Arbeitsvertrag nachgehen und mindestens 20 Stunden pro Woche bei demselben Arbeitgeber beschäftigt oder selbständig erwerbend sein</li> </ul>" },
          { "q": "Welche Deckungen kann ich wählen?", "a": "Abgedeckt ist der in der Versicherungsbestätigung aufgeführten Teil (40% oder 80%) der monatliche Rate der Hypothekarverpflichtungen (effektiver Hypothekarzins inkl. allfälligem Amortisationsbetrag aller von der versicherten Person bei der Post Finance im Rahmen des Hypothekarvertrages abgeschlossenen Hypothekartranchen) bei einer vollständigen Arbeitsunfähigkeit infolge Krankheit / Unfall oder einer unverschuldeten Arbeitslosigkeit." },
          { "q": "Weshalb unterscheidet sich die Prämie?", "a": "Die versicherte Rate wird jährlich den effektiven Hypothekarverpflichtungen (effektiver Hypothekarzins inkl. allfälligem Amortisationsbetrag) angepasst. Bei SARON Anteilen wird der zu dieser Zeit geltende Zinssatz verwendet." },
          { "q": "Wie melde ich einen Leistungsfall?", "a": "Sie können den Prozess ganz einfach im Kunden-Dashboard starten, indem Sie auf 'Meine Versicherungen' und dort anschliessend auf das Plus-Symbol klicken, 'Versicherungsfall melden' auswählen und den Anweisungen auf dem Bildschirm für die Zahlungsschutzversicherung folgen." },
          { "q": "Was ist eine 'Wartefrist'?", "a": "Die Wartefrist ist der Zeitraum, in dem nach einem versicherten Ereignis noch keine Leistungen bezogen werden können." },
          { "q": "Was ist eine 'Karenzfrist'?", "a": "Eine Karenzfrist bei Versicherungen bezieht sich auf einen festgelegten Zeitraum, der nach Abschluss einer Versicherungspolice verstreichen muss, bevor bestimmte Leistungen oder Deckungen in Kraft treten. Während dieser Karenzfrist können auch im Schadenfall keine Versicherungsansprüche geltend gemacht werden. Die Karenzfrist dient dazu, die Versicherung vor Missbrauch zu schützen und sicherzustellen, dass der Versicherungsnehmer regelmässige Beiträge zahlt, bevor Leistungen in Anspruch genommen werden können." },
        ]
      }
    },
    decls: {
      vag45: {
        content: [],
        name: "Beraterinformationen",
        link: "assets/KundenbriefVAG_It_V03.05.pdf"
      },
      smokerStatus: {
        content: [
          "<div class=\"flex items-start text-body\"> Ausgewählt während dem Gespräch mit Ihrem Kundenberater: </div> <div class=\"w-full inline-flex flex-row items-center items-center\"> <EmptyCircle class=\"w-6 h-8 stroke-2 mr-2\" /> <div class=\"flex-1 text-base\">Ja, regelmässig</div> </div> <div class=\"w-full inline-flex flex-row items-center items-center\"> <EmptyCircle class=\"w-6 h-8 stroke-2 mr-2\" /> <div class=\"flex-1 text-base\">Ja, gelegentlich</div> </div> <div class=\"w-full inline-flex flex-row items-center items-center\"> <CheckCircle class=\"w-6 h-8 stroke-2 mr-2\" /> <div class=\"flex-1 text-base\"><b>Nein. Ich habe in den letzten 12 Monaten keine Tabak oder Tabakersatzprodukte* konsumiert.</b></div> </div> <div class=\"flex items-start text-body\"> *Darunter fallen: Zigaretten oder Zigarillos, Zigarren, Pfeife, elektronische Zigaretten, Kau- oder Schnupftabak, Nikotin Gum / Patch oder Wasserpfeife (Shisha) </div>"
        ],
        name: "Konsumieren Sie Tabak oder Tabakersatzprodukte?"
      },
      declarationOfAccession: {
        content: [
          "Ho tra i 18 e i 60 anni, non sono in pensione e la mia residenza principale è in Svizzera.",
          "Ho un posto di lavoro a tempo indeterminato e indeterminato e lavoro più di 20 ore settimanali per un datore di lavoro o sono un lavoratore autonomo. Il contratto di lavoro è un lavoro a tempo indeterminato e retribuito in Svizzera.",
          "Prendo atto che la copertura assicurativa vale solo dopo la scadenza dei termini indicati nelle Condizioni Generali.",
          "Sono particolarmente consapevole che malattie preesistenti e malattie esistenti possono essere escluse dalla copertura per inabilità al lavoro. La copertura assicurativa in caso di inabilità al lavoro completa non si estende ai sinistri (malattie preesistenti) che si riferiscono ad un incapacità al lavoro esistente o malattie esistenti (in particolare malattie o infortuni due anni prima dell’inizio dell’assicurazione, che mi sono già note o avrebbero dovuto essere conosciute.",
          "Sono consapevole che in qualità di lavoratore autonomo, imprenditore ecc. non ho alcuna copertura assicurativa contro la disoccupazione. Lo stesso vale per i soci dirigenti di un’azienda e per i dipendenti senior con una “posizione simile a un datore di lavoro” che non sono hanno diritto all’indennità di disoccupazione a causa della loro posizione speciale all’interno dell’azienda."
        ],
        name: "Dichiarazione di adesione"
      },
      gtc: {
        content: [
          "Si prega di aprire il link alle CGV e confermare di aver letto e compreso il contenuto del documento:"
        ],
        name: "Condizioni generali di assicurazione"
      },
      gtcDI: {
        content: [
          "Bitte öffnen Sie den Link zu den <a href=\"assets/AVB_DI_It.pdf\" class=\"underline underline-offset-1\" target=\"_blank\">AVB</a> und bestätigen Sie, den Inhalt des Dokumentes gelesen und verstanden zu haben:"
        ],
        name: "Allg. Versicherungsbedingungen",
        link: "assets/AVB_DI_It.pdf"
      },
      gtcPPI: {
        content: [
          "Bitte öffnen Sie den Link zu den <a href=\"assets/AVB_PP_It.pdf\" class=\"underline underline-offset-1\" target=\"_blank\">AVB</a> und bestätigen Sie, den Inhalt des Dokumentes gelesen und verstanden zu haben:"
        ],
        name: "Allg. Versicherungsbedingungen",
        link: "assets/AVB_PP_It.pdf"
      },
      healthDeclaration: {
        content: [
          "Sono fisicamente e mentalmente sano, cioè non soffro di malattie croniche, problemi di salute o difetti congeniti.",
          "Non sono in cura e non è previsto alcun trattamento.",
          "Non sono mai stato trattato per più di un anno e non ho mai assunto alcun farmaco (compresi antidolorifici, sonniferi o antidepressivi) per più di un anno.",
          "Non ho preso alcun farmaco negli ultimi sei mesi.",
          "Sono pienamente in grado di lavorare e non sono mai stato incapace di lavorare o di lavorare per più di due mesi consecutivi negli ultimi cinque anni."
        ],
        name: "Dichiarazione dello stato di salute"
      },
      powerOfAttorney: {
        content: [
          "Autorizzo AXA Leben AG, se necessario, a ottenere informazioni da altre società AXA, altri istituti assicurativi, organi ufficiali e in particolare da medici, terapisti, cliniche, istituti di cura, datori di lavoro, casse pensioni e casse malati, istituti di previdenza e di libero passaggio per determinare l’obbligo di pagare le prestazioni in caso di decesso, alle casse di compensazione, all’Assicurazione federale per l’invalidità nonché ad altre persone e organismi che dispongono di informazioni rilevanti e per trasmettere i dati personali ai riassicuratori e ad altri istituti assicurativi appartenenti all’Assicurazione federale per l’invalidità Gruppo AXA nella misura necessaria e liberare le persone e gli organismi sopra menzionati dal loro obbligo di riservatezza. Tale esenzione dall’obbligo di riservatezza vale espressamente anche dopo la morte."
        ],
        name: "Dichiarazione di procura"
      }
    },
    description: "Italiano",
    error: {
      atLeast1LowercaseLetter: "Almeno 3 lettere minuscole",
      atLeast1Numeral: "Almeno 2 numeri (0-9)",
      atLeast1SpecialChar: "Almeno 1 carattere speciale (!@#$%^&*()-_+.)",
      atLeast1UppercaseLetter: "Almeno 2 lettere maiuscole",
      atLeast8CharsLong: "Almeno 8 caratteri",
      codeRequired: "Code erforderlich",
      confirmPasswordIsRequired: "È richiesta la conferma della password",
      newPasswordIsRequired: "È richiesta una nuova password",
      passwordsMustMatch: "Le password devono corrispondere",
    },
    isDefault: false,
    label: {
      smokerStatusIsTruthful: "Ich bestätige, dass diese Aussage der Wahrheit entspricht",
      aboveInformationIsTruthful: "Le informazioni di cui sopra corrispondono, per quanto a conoscenza e coscienza, alla verità.",
      accountHolderName: "Nome del titolare del conto",
      address1: "Riga indirizzo 1",
      address2: "Riga indirizzo 2",
      annual: "Annuale",
      bankName: "Nome della banca",
      bankPostalCode: "Codice postale della banca",
      byCheckingBoxReadUnderstoodTermsAndConditions: "Selezionando questa casella, confermo di aver letto e compreso i Termini e Condizioni Generali.",
      city: "Città",
      confirmationPending: "Bestätigung ausstehend",
      confirmed: "Bestätigt",
      confirmPassword: "Conferma la password",
      contractNumber: "Numero di contratto",
      coverageAmountDI: "Todesfallkapital",
      coverageAmountPPI: "Tariffa mensile assicurata",
      coverageTotal: "Copertura",
      coveragePerMonth: "Copertura al mese",
      customerType: "Tipo di cliente",
      dateOfEvent: "Data dell’evento assicurato",
      desiredPaymentFrequency: "Frequenza di pagamento desiderata",
      dueBy: "Data di scadenza",
      durationOfInsurance: "Durata della copertura assicurativa",
      email: "E-mail",
      firstName: "Nome",
      grossPrice: "Prezzo lordo",
      halfYearly: "Semestrale",
      iban: "IBAN",
      incapacityForWorkAccident: "Incapacità al lavoro per infortunio",
      incapacityForWorkIllness: "Incapacità al lavoro per malattia",
      incidentDate: "Data dell’incidente",
      insuranceEvent: "Evento assicurato",
      invoiceNumber: "Numero della fattura",
      issuedAt: "Data di emissione",
      lastName: "Cognome",
      monthly: "Mensile",
      newPassword: "Nuova password",
      offeredBy: "",
      paidAt: "Data di pagamento",
      payment: "Pagamento",
      phone: "Numero di telefono",
      policyNumber: "Numero di polizza",
      postalCode: "Codice postale",
      premium: "Premio",
      premiumPerMonth: "Premio al mese",
      costPerMonth: "Kosten pro Monat",
      premiumPerQuarter: "Kosten pro Quartal",
      premiumPerYear: "Kosten pro Jahr",
      serviceFees: "Monatliche Gebühr für quartalsweise Zahlung",
      quarterly: "Trimestrale",
      resetPassword: "Reimposta password",
      startDate: "Data d’inizio",
      status: "Stato",
      subStatus: "Sottostato",
      total: "In totale",
      totalPremiumPerMonth: "Premio totale al mese",
      unemployment: "Disoccupazione",
      validFrom: "Valido dal",
      validTo: "Valido fino al",
      yearly: "Annuale",
      yourCode: "Il suo codice",
      yourEmail: "La sua e-mail",
      yourPassword: "La sua password",
      searchFaq: "Suche",
      dataprotectionprovisionslink: "<a href=\"https://www.axa.ch/de/informationen/datenschutz.html\" class=\"underline\" target=\"_blank\">Disposizioni in materia di protezione dei dati</a>"
    },
    menu: {
      activateAccount: "Attiva account",
      cart: "Carrello",
      claim: "Danno",
      contactRM: "Contatta consulente",
      installments: "Rate",
      insurance: "Assicurazione",
      insuranceCancellation: "Annulla l’assicurazione",
      invoices: "Fatture",
      login: "Login",
      logout: "Logout",
      messages: "Messaggi",
      orderOfBeneficiaries: "",
      outstandingInvoices: "Fatture in sospeso",
      policies: "Polizze",
      profile: "Profilo",
      reportClaim: "Segnalare danno",
      support: "Supporto"
    },
    noData: {
      activePolicies: "Nessuna polizza assicurativa attiva da visualizzare.",
      claims: "Nessun danno segnalato.",
    },
    notice: {
      areYouSureYouWantCancelInsurance: "Sei sicuro di voler annullare la tua assicurazione?",
      areYouSureYouWantExerciseRightOfCancellation: "Sei sicuro di voler esercitare il tuo diritto di recesso?",
      changeSuccessful: "",
      chooseOrderOfBeneficiariesForDeathInsurance: "",
      ifInformationIsIncorrectPleaseContactRm: "",
      insuranceEndsOn: "La copertura assicurativa termina:",
      pleaseCheckEmail: "Controlla la sua casella di posta elettronica per reimpostare la password.",
      pleaseCheckPersonalInformation: "Si prega di controllare i propri dati personali e correggerli se necessario.",
      pleaseContactYourAdvisor: "Bitte wenden Sie sich an Ihren Kundenberater.",
      pleaseEnterCodeWeSentToNumber: "Inserisci il codice che abbiamo inviato al {0}.",
      pleaseVerifyMobileNumber: "Per favore verifichi il suo numero di cellulare.",
      resendSms: "Invia nuovamente l’SMS",
      sinceWhenAreYouDisabled: "Da quanto tempo è inabile al lavoro?",
      somethingWentWrongPleaseTryAgain: "",
      success: "Successo!",
      thankYouFindYourClaimHere: "Grazie per aver dedicato del tempo. Puoi trovare il rapporto sui reclami nella dashboard del cliente sotto <b>Danno</b>.",
      thankYouForApplicationFindYourConfirmation: "Puoi visualizzare la tua offerta in qualsiasi momento nel tuo account personale. Ti invieremo anche l’accesso all’account cliente alla tua email.",
      thankYouYouCanNowSubmitMembershipApplication: "",
      whenDoesYourEmploymentEnd: "Quando termina il vostro rapporto di lavoro?",
      youAreCancellingInsuranceRetroactivelyPleaseNoteCancellationTakesEffectImmediately: "State per disdire il rapporto assicurativo con effetto retroattivo dall’inizio dell’assicurazione. Si prega di notare che la revoca ha effetto immediato e irrevocabile.",
      youAreInTheProcessOfCancellingInsurancePleaseNoteEndOfInsuranceTermListedBelow: "Stai per disdire l’assicurazione che hai scelto. Si tenga presente che la scadenza della durata assicurativa è indicata di seguito.",
      youHaveSuccessfullySubmittedYourClaimAxaWillContactYou: "Hai inviato con successo la tua richiesta di risarcimento assicurativo. AXA ti contatterà via e-mail.",
      yourClaimHasBeenSubmitted: "Il suo reclamo è stato inviato",
      yourProductIsActivated: "Il suo prodotto viene attivato",
      yearlyDiscount: "Bitte beachten Sie, dass unser Servicedienstleister (Additiv AG) Ihre Zahlung um CHF 20.- pro Quartal rabattiert, wenn Sie die jährliche Zahlungsweise wählen.",
    },
    policy: {
      additionalDocumentApprovals: "Si prega di leggere e confermare i seguenti contenuti:",
      installment: "Rata",
      installmentXOutOfY: "Rata {0} di {1}",
      noDocuments: "Nessun documento visibile da visualizzare.",
      noInstallments: "Nessuna rata di assicurazione da visualizzare.",
      policyStart: "Inizio della polizza",
      yourDocuments: "I documenti"
    },
    products: {
      DI: {
        description: "Per proteggere i vostri cari",
        name: "Protezione della famiglia",
        customName: "Protezione della famiglia"
      },
      PPI: {
        description: "Per garantire il pagamento del credito",
        name: "Protezione dei pagamenti",
        customName: "Protezione dei pagamenti"
      }
    },
    smoker: {
      noIHaveNotConsumedTobaccoInLast12Months: "",
      selectedDuringTheMeetingWithAccountManager: "",
      thisIncludesCigarettesEtAl: "",
      yesOccasionally: "",
      yesRegularly: "",
    },
    title: {
      bankDetails: "Coordinate bancarie",
      cancelInsurance: "Annulla l’assicurazione",
      cart: "Carrello",
      choosePolicy: "Seleziona la polizza",
      // Sinistro: Quando si verifica un danno alla cosa assicurata e questo rientra nella casistica prevista dalla polizza e la data di accadimento è compresa nel periodo di validità della copertura assicurativa, l’evento assume il nome di "sinistro".
      claimDetails: "Sinistro",
      confirmNewPassword: "Conferma nuova password",
      insuranceDamage: "Sinistri",
      invoices: "Fatture",
      login: "Login",
      orderOfBeneficiaries: "",
      pleaseReadAndConfirmPrivacyPolicy: "Si prega di leggere e confermare l’informativa sulla privacy",
      provisionalQuote: "Offerta provvisoria",
      resetPassword: "Reimposta la password",
      setPasswordForYourPersonalArea: "Imposta una password per la tua area cliente personale",
      summary: "Conferma",
      welcome: "Benvenuto",
      welcomeJohnDoe: "Benvenuto, {0}",
      yourActivePolicies: "Le vostre polizze",
      yourActivePolicy: "La tua assicurazione",
      yourActiveProducts: "I vostri prodotti attivi",
      yourOffers: "Offerta/e",
      yourOffersAccepted: "Le tue assicurazioni",
      yourBroker: "Ihre Kundenberater/in"
    }
  }
};